(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GameScene = require("./../scenes/GameScene");

var _GameScene2 = _interopRequireDefault(_GameScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 */
var Application = function () {
    function Application() {
        _classCallCheck(this, Application);

        //--bind the asset manager functions so we can call them with a short local variable--//
        _Common2.default.assets.texture = _Common2.default.assets.texture.bind(_Common2.default.assets);
        _Common2.default.assets.json = _Common2.default.assets.json.bind(_Common2.default.assets);

        //--load saves--//
        _Common2.default.loadMute();
        _Common2.default.loadGame();

        var j = _Common2.default.assets.json;
        _Common2.default.config = j("config");
    }

    _createClass(Application, [{
        key: "init",
        value: function init() {

            this.showGameScene();
        }
    }, {
        key: "showGameScene",
        value: function showGameScene() {
            var scene = new _GameScene2.default();
            scene.signals.next.add(function () {
                // this.showQuizScene();
            }, this);

            _Common2.default.scene.show(scene);
            return scene;
        }
    }]);

    return Application;
}();

exports.default = Application;

},{"./../scenes/GameScene":11,"./Common":4}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bump = function () {
    function Bump() {
        var renderingEngine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PIXI;

        _classCallCheck(this, Bump);

        if (renderingEngine === undefined) throw new Error("Please assign a rendering engine in the constructor before using bump.js");

        this.renderer = "pixi";
    }

    //`addCollisionProperties` adds extra properties to sprites to help
    //simplify the collision code. It won't add these properties if they
    //already exist on the sprite. After these properties have been
    //added, this methods adds a Boolean property to the sprite called `_bumpPropertiesAdded`
    //and sets it to `true` to flag that the sprite has these
    //new properties


    _createClass(Bump, [{
        key: "addCollisionProperties",
        value: function addCollisionProperties(sprite) {

            //Add properties to Pixi sprites
            if (this.renderer === "pixi") {

                //gx
                if (sprite.gx === undefined) {
                    Object.defineProperty(sprite, "gx", {
                        get: function get() {
                            return sprite.getGlobalPosition().x;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //gy
                if (sprite.gy === undefined) {
                    Object.defineProperty(sprite, "gy", {
                        get: function get() {
                            return sprite.getGlobalPosition().y;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //centerX
                if (sprite.centerX === undefined) {
                    Object.defineProperty(sprite, "centerX", {
                        get: function get() {
                            return sprite.x + sprite.width / 2;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //centerY
                if (sprite.centerY === undefined) {
                    Object.defineProperty(sprite, "centerY", {
                        get: function get() {
                            return sprite.y + sprite.height / 2;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //halfWidth
                if (sprite.halfWidth === undefined) {
                    Object.defineProperty(sprite, "halfWidth", {
                        get: function get() {
                            return sprite.width / 2;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //halfHeight
                if (sprite.halfHeight === undefined) {
                    Object.defineProperty(sprite, "halfHeight", {
                        get: function get() {
                            return sprite.height / 2;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //xAnchorOffset
                if (sprite.xAnchorOffset === undefined) {
                    Object.defineProperty(sprite, "xAnchorOffset", {
                        get: function get() {
                            if (sprite.anchor !== undefined) {
                                return sprite.width * sprite.anchor.x;
                            } else {
                                return 0;
                            }
                        },

                        enumerable: true, configurable: true
                    });
                }

                //yAnchorOffset
                if (sprite.yAnchorOffset === undefined) {
                    Object.defineProperty(sprite, "yAnchorOffset", {
                        get: function get() {
                            if (sprite.anchor !== undefined) {
                                return sprite.height * sprite.anchor.y;
                            } else {
                                return 0;
                            }
                        },

                        enumerable: true, configurable: true
                    });
                }

                if (sprite.circular && sprite.radius === undefined) {
                    Object.defineProperty(sprite, "radius", {
                        get: function get() {
                            return sprite.width / 2;
                        },

                        enumerable: true, configurable: true
                    });
                }

                //Earlier code - not needed now.
                /*
                 Object.defineProperties(sprite, {
                 "gx": {
                 get(){return sprite.getGlobalPosition().x},
                 enumerable: true, configurable: true
                 },
                 "gy": {
                 get(){return sprite.getGlobalPosition().y},
                 enumerable: true, configurable: true
                 },
                 "centerX": {
                 get(){return sprite.x + sprite.width / 2},
                 enumerable: true, configurable: true
                 },
                 "centerY": {
                 get(){return sprite.y + sprite.height / 2},
                 enumerable: true, configurable: true
                 },
                 "halfWidth": {
                 get(){return sprite.width / 2},
                 enumerable: true, configurable: true
                 },
                 "halfHeight": {
                 get(){return sprite.height / 2},
                 enumerable: true, configurable: true
                 },
                 "xAnchorOffset": {
                 get(){
                 if (sprite.anchor !== undefined) {
                 return sprite.height * sprite.anchor.x;
                 } else {
                 return 0;
                 }
                 },
                 enumerable: true, configurable: true
                 },
                 "yAnchorOffset": {
                 get(){
                 if (sprite.anchor !== undefined) {
                 return sprite.width * sprite.anchor.y;
                 } else {
                 return 0;
                 }
                 },
                 enumerable: true, configurable: true
                 }
                 });
                 */
            }

            //Add a Boolean `_bumpPropertiesAdded` property to the sprite to flag it
            //as having these new properties
            sprite._bumpPropertiesAdded = true;
        }

        /*
         hitTestPoint
         ------------
           Use it to find out if a point is touching a circular or rectangular sprite.
         Parameters:
         a. An object with `x` and `y` properties.
         b. A sprite object with `x`, `y`, `centerX` and `centerY` properties.
         If the sprite has a `radius` property, the function will interpret
         the shape as a circle.
         */

    }, {
        key: "hitTestPoint",
        value: function hitTestPoint(point, sprite) {

            //Add collision properties
            if (!sprite._bumpPropertiesAdded) this.addCollisionProperties(sprite);

            var shape = void 0,
                left = void 0,
                right = void 0,
                top = void 0,
                bottom = void 0,
                vx = void 0,
                vy = void 0,
                magnitude = void 0,
                hit = void 0;

            //Find out if the sprite is rectangular or circular depending
            //on whether it has a `radius` property
            if (sprite.radius) {
                shape = "circle";
            } else {
                shape = "rectangle";
            }

            //Rectangle
            if (shape === "rectangle") {

                //Get the position of the sprite's edges
                left = sprite.x - sprite.xAnchorOffset;
                right = sprite.x + sprite.width - sprite.xAnchorOffset;
                top = sprite.y - sprite.yAnchorOffset;
                bottom = sprite.y + sprite.height - sprite.yAnchorOffset;

                //Find out if the point is intersecting the rectangle
                hit = point.x > left && point.x < right && point.y > top && point.y < bottom;
            }

            //Circle
            if (shape === "circle") {

                //Find the distance between the point and the
                //center of the circle
                vx = point.x - sprite.x - sprite.width / 2 + sprite.xAnchorOffset;
                vy = point.y - sprite.y - sprite.height / 2 + sprite.yAnchorOffset;
                magnitude = Math.sqrt(vx * vx + vy * vy);

                //The point is intersecting the circle if the magnitude
                //(distance) is less than the circle's radius
                hit = magnitude < sprite.radius;
            }

            //`hit` will be either `true` or `false`
            return hit;
        }

        /*
         hitTestCircle
         -------------
           Use it to find out if two circular sprites are touching.
         Parameters:
         a. A sprite object with `centerX`, `centerY` and `radius` properties.
         b. A sprite object with `centerX`, `centerY` and `radius`.
         */

    }, {
        key: "hitTestCircle",
        value: function hitTestCircle(c1, c2) {
            var global = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


            //Add collision properties
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);
            if (!c2._bumpPropertiesAdded) this.addCollisionProperties(c2);

            var vx = void 0,
                vy = void 0,
                magnitude = void 0,
                combinedRadii = void 0,
                hit = void 0;

            //Calculate the vector between the circles� center points
            if (global) {
                //Use global coordinates
                vx = c2.gx + c2.width / 2 - c2.xAnchorOffset - (c1.gx + c1.width / 2 - c1.xAnchorOffset);
                vy = c2.gy + c2.width / 2 - c2.yAnchorOffset - (c1.gy + c1.width / 2 - c1.yAnchorOffset);
            } else {
                //Use local coordinates
                vx = c2.x + c2.width / 2 - c2.xAnchorOffset - (c1.x + c1.width / 2 - c1.xAnchorOffset);
                vy = c2.y + c2.width / 2 - c2.yAnchorOffset - (c1.y + c1.width / 2 - c1.yAnchorOffset);
            }

            //Find the distance between the circles by calculating
            //the vector's magnitude (how long the vector is)
            magnitude = Math.sqrt(vx * vx + vy * vy);

            //Add together the circles' total radii
            combinedRadii = c1.radius + c2.radius;

            //Set `hit` to `true` if the distance between the circles is
            //less than their `combinedRadii`
            hit = magnitude < combinedRadii;

            //`hit` will be either `true` or `false`
            return hit;
        }

        /*
         circleCollision
         ---------------
           Use it to prevent a moving circular sprite from overlapping and optionally
         bouncing off a non-moving circular sprite.
         Parameters:
         a. A sprite object with `x`, `y` `centerX`, `centerY` and `radius` properties.
         b. A sprite object with `x`, `y` `centerX`, `centerY` and `radius` properties.
         c. Optional: true or false to indicate whether or not the first sprite
         should bounce off the second sprite.
         The sprites can contain an optional mass property that should be greater than 1.
           */

    }, {
        key: "circleCollision",
        value: function circleCollision(c1, c2) {
            var bounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var global = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


            //Add collision properties
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);
            if (!c2._bumpPropertiesAdded) this.addCollisionProperties(c2);

            var magnitude = void 0,
                combinedRadii = void 0,
                overlap = void 0,
                vx = void 0,
                vy = void 0,
                dx = void 0,
                dy = void 0,
                s = {},
                hit = false;

            //Calculate the vector between the circles� center points

            if (global) {
                //Use global coordinates
                vx = c2.gx + c2.width / 2 - c2.xAnchorOffset - (c1.gx + c1.width / 2 - c1.xAnchorOffset);
                vy = c2.gy + c2.width / 2 - c2.yAnchorOffset - (c1.gy + c1.width / 2 - c1.yAnchorOffset);
            } else {
                //Use local coordinates
                vx = c2.x + c2.width / 2 - c2.xAnchorOffset - (c1.x + c1.width / 2 - c1.xAnchorOffset);
                vy = c2.y + c2.width / 2 - c2.yAnchorOffset - (c1.y + c1.width / 2 - c1.yAnchorOffset);
            }

            //Find the distance between the circles by calculating
            //the vector's magnitude (how long the vector is)
            magnitude = Math.sqrt(vx * vx + vy * vy);

            //Add together the circles' combined half-widths
            combinedRadii = c1.radius + c2.radius;

            //Figure out if there's a collision
            if (magnitude < combinedRadii) {

                //Yes, a collision is happening
                hit = true;

                //Find the amount of overlap between the circles
                overlap = combinedRadii - magnitude;

                //Add some "quantum padding". This adds a tiny amount of space
                //between the circles to reduce their surface tension and make
                //them more slippery. "0.3" is a good place to start but you might
                //need to modify this slightly depending on the exact behaviour
                //you want. Too little and the balls will feel sticky, too much
                //and they could start to jitter if they're jammed together
                var quantumPadding = 0.3;
                overlap += quantumPadding;

                //Normalize the vector
                //These numbers tell us the direction of the collision
                dx = vx / magnitude;
                dy = vy / magnitude;

                //Move circle 1 out of the collision by multiplying
                //the overlap with the normalized vector and subtract it from
                //circle 1's position
                c1.x -= overlap * dx;
                c1.y -= overlap * dy;

                //Bounce
                if (bounce) {
                    //Create a collision vector object, `s` to represent the bounce "surface".
                    //Find the bounce surface's x and y properties
                    //(This represents the normal of the distance vector between the circles)
                    s.x = vy;
                    s.y = -vx;

                    //Bounce c1 off the surface
                    this.bounceOffSurface(c1, s);
                }
            }
            return hit;
        }

        /*
         movingCircleCollision
         ---------------------
           Use it to make two moving circles bounce off each other.
         Parameters:
         a. A sprite object with `x`, `y` `centerX`, `centerY` and `radius` properties.
         b. A sprite object with `x`, `y` `centerX`, `centerY` and `radius` properties.
         The sprites can contain an optional mass property that should be greater than 1.
           */

    }, {
        key: "movingCircleCollision",
        value: function movingCircleCollision(c1, c2) {
            var global = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


            //Add collision properties
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);
            if (!c2._bumpPropertiesAdded) this.addCollisionProperties(c2);

            var combinedRadii = void 0,
                overlap = void 0,
                xSide = void 0,
                ySide = void 0,

            //`s` refers to the distance vector between the circles
            s = {},
                p1A = {},
                p1B = {},
                p2A = {},
                p2B = {},
                hit = false;

            //Apply mass, if the circles have mass properties
            c1.mass = c1.mass || 1;
            c2.mass = c2.mass || 1;

            //Calculate the vector between the circles� center points
            if (global) {

                //Use global coordinates
                s.vx = c2.gx + c2.radius - c2.xAnchorOffset - (c1.gx + c1.radius - c1.xAnchorOffset);
                s.vy = c2.gy + c2.radius - c2.yAnchorOffset - (c1.gy + c1.radius - c1.yAnchorOffset);
            } else {

                //Use local coordinates
                s.vx = c2.x + c2.radius - c2.xAnchorOffset - (c1.x + c1.radius - c1.xAnchorOffset);
                s.vy = c2.y + c2.radius - c2.yAnchorOffset - (c1.y + c1.radius - c1.yAnchorOffset);
            }

            //Find the distance between the circles by calculating
            //the vector's magnitude (how long the vector is)
            s.magnitude = Math.sqrt(s.vx * s.vx + s.vy * s.vy);

            //Add together the circles' combined half-widths
            combinedRadii = c1.radius + c2.radius;

            //Figure out if there's a collision
            if (s.magnitude < combinedRadii) {

                //Yes, a collision is happening
                hit = true;

                //Find the amount of overlap between the circles
                overlap = combinedRadii - s.magnitude;

                //Add some "quantum padding" to the overlap
                overlap += 0.3;

                //Normalize the vector.
                //These numbers tell us the direction of the collision
                s.dx = s.vx / s.magnitude;
                s.dy = s.vy / s.magnitude;

                //Find the collision vector.
                //Divide it in half to share between the circles, and make it absolute
                s.vxHalf = Math.abs(s.dx * overlap / 2);
                s.vyHalf = Math.abs(s.dy * overlap / 2);

                //Find the side that the collision is occurring on
                c1.x > c2.x ? xSide = 1 : xSide = -1;
                c1.y > c2.y ? ySide = 1 : ySide = -1;

                //Move c1 out of the collision by multiplying
                //the overlap with the normalized vector and adding it to
                //the circles' positions
                c1.x = c1.x + s.vxHalf * xSide;
                c1.y = c1.y + s.vyHalf * ySide;

                //Move c2 out of the collision
                c2.x = c2.x + s.vxHalf * -xSide;
                c2.y = c2.y + s.vyHalf * -ySide;

                //1. Calculate the collision surface's properties

                //Find the surface vector's left normal
                s.lx = s.vy;
                s.ly = -s.vx;

                //2. Bounce c1 off the surface (s)

                //Find the dot product between c1 and the surface
                var dp1 = c1.vx * s.dx + c1.vy * s.dy;

                //Project c1's velocity onto the collision surface
                p1A.x = dp1 * s.dx;
                p1A.y = dp1 * s.dy;

                //Find the dot product of c1 and the surface's left normal (s.lx and s.ly)
                var dp2 = c1.vx * (s.lx / s.magnitude) + c1.vy * (s.ly / s.magnitude);

                //Project the c1's velocity onto the surface's left normal
                p1B.x = dp2 * (s.lx / s.magnitude);
                p1B.y = dp2 * (s.ly / s.magnitude);

                //3. Bounce c2 off the surface (s)

                //Find the dot product between c2 and the surface
                var dp3 = c2.vx * s.dx + c2.vy * s.dy;

                //Project c2's velocity onto the collision surface
                p2A.x = dp3 * s.dx;
                p2A.y = dp3 * s.dy;

                //Find the dot product of c2 and the surface's left normal (s.lx and s.ly)
                var dp4 = c2.vx * (s.lx / s.magnitude) + c2.vy * (s.ly / s.magnitude);

                //Project c2's velocity onto the surface's left normal
                p2B.x = dp4 * (s.lx / s.magnitude);
                p2B.y = dp4 * (s.ly / s.magnitude);

                //4. Calculate the bounce vectors

                //Bounce c1
                //using p1B and p2A
                c1.bounce = {};
                c1.bounce.x = p1B.x + p2A.x;
                c1.bounce.y = p1B.y + p2A.y;

                //Bounce c2
                //using p1A and p2B
                c2.bounce = {};
                c2.bounce.x = p1A.x + p2B.x;
                c2.bounce.y = p1A.y + p2B.y;

                //Add the bounce vector to the circles' velocity
                //and add mass if the circle has a mass property
                c1.vx = c1.bounce.x / c1.mass;
                c1.vy = c1.bounce.y / c1.mass;
                c2.vx = c2.bounce.x / c2.mass;
                c2.vy = c2.bounce.y / c2.mass;
            }
            return hit;
        }

        /*
         multipleCircleCollision
         -----------------------
           Checks all the circles in an array for a collision against
         all the other circles in an array, using `movingCircleCollision` (above)
         */

    }, {
        key: "multipleCircleCollision",
        value: function multipleCircleCollision(arrayOfCircles) {
            var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            for (var i = 0; i < arrayOfCircles.length; i++) {

                //The first circle to use in the collision check
                var c1 = arrayOfCircles[i];
                for (var j = i + 1; j < arrayOfCircles.length; j++) {

                    //The second circle to use in the collision check
                    var c2 = arrayOfCircles[j];

                    //Check for a collision and bounce the circles apart if
                    //they collide. Use an optional `mass` property on the sprite
                    //to affect the bounciness of each marble
                    this.movingCircleCollision(c1, c2, global);
                }
            }
        }

        /*
         rectangleCollision
         ------------------
           Use it to prevent two rectangular sprites from overlapping.
         Optionally, make the first rectangle bounce off the second rectangle.
         Parameters:
         a. A sprite object with `x`, `y` `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
         b. A sprite object with `x`, `y` `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
         c. Optional: true or false to indicate whether or not the first sprite
         should bounce off the second sprite.
         */

    }, {
        key: "rectangleCollision",
        value: function rectangleCollision(r1, r2) {
            var bounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var global = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


            //Add collision properties
            if (!r1._bumpPropertiesAdded) this.addCollisionProperties(r1);
            if (!r2._bumpPropertiesAdded) this.addCollisionProperties(r2);

            var collision = void 0,
                combinedHalfWidths = void 0,
                combinedHalfHeights = void 0,
                overlapX = void 0,
                overlapY = void 0,
                vx = void 0,
                vy = void 0;

            //Calculate the distance vector
            if (global) {
                vx = r1.gx + Math.abs(r1.halfWidth) - r1.xAnchorOffset - (r2.gx + Math.abs(r2.halfWidth) - r2.xAnchorOffset);
                vy = r1.gy + Math.abs(r1.halfHeight) - r1.yAnchorOffset - (r2.gy + Math.abs(r2.halfHeight) - r2.yAnchorOffset);
            } else {
                //vx = r1.centerX - r2.centerX;
                //vy = r1.centerY - r2.centerY;
                vx = r1.x + Math.abs(r1.halfWidth) - r1.xAnchorOffset - (r2.x + Math.abs(r2.halfWidth) - r2.xAnchorOffset);
                vy = r1.y + Math.abs(r1.halfHeight) - r1.yAnchorOffset - (r2.y + Math.abs(r2.halfHeight) - r2.yAnchorOffset);
            }

            //Figure out the combined half-widths and half-heights
            combinedHalfWidths = Math.abs(r1.halfWidth) + Math.abs(r2.halfWidth);
            combinedHalfHeights = Math.abs(r1.halfHeight) + Math.abs(r2.halfHeight);

            //Check whether vx is less than the combined half widths
            if (Math.abs(vx) < combinedHalfWidths) {

                //A collision might be occurring!
                //Check whether vy is less than the combined half heights
                if (Math.abs(vy) < combinedHalfHeights) {

                    //A collision has occurred! This is good!
                    //Find out the size of the overlap on both the X and Y axes
                    overlapX = combinedHalfWidths - Math.abs(vx);
                    overlapY = combinedHalfHeights - Math.abs(vy);

                    //The collision has occurred on the axis with the
                    //*smallest* amount of overlap. Let's figure out which
                    //axis that is

                    if (overlapX >= overlapY) {
                        //The collision is happening on the X axis
                        //But on which side? vy can tell us

                        if (vy > 0) {
                            collision = "top";
                            //Move the rectangle out of the collision
                            r1.y = r1.y + overlapY;
                        } else {
                            collision = "bottom";
                            //Move the rectangle out of the collision
                            r1.y = r1.y - overlapY;
                        }

                        //Bounce
                        if (bounce) {
                            r1.vy *= -1;

                            /*Alternative
                             //Find the bounce surface's vx and vy properties
                             var s = {};
                             s.vx = r2.x - r2.x + r2.width;
                             s.vy = 0;
                               //Bounce r1 off the surface
                             //this.bounceOffSurface(r1, s);
                             */
                        }
                    } else {
                        //The collision is happening on the Y axis
                        //But on which side? vx can tell us

                        if (vx > 0) {
                            collision = "left";
                            //Move the rectangle out of the collision
                            r1.x = r1.x + overlapX;
                        } else {
                            collision = "right";
                            //Move the rectangle out of the collision
                            r1.x = r1.x - overlapX;
                        }

                        //Bounce
                        if (bounce) {
                            r1.vx *= -1;

                            /*Alternative
                             //Find the bounce surface's vx and vy properties
                             var s = {};
                             s.vx = 0;
                             s.vy = r2.y - r2.y + r2.height;
                               //Bounce r1 off the surface
                             this.bounceOffSurface(r1, s);
                             */
                        }
                    }
                } else {
                        //No collision
                    }
            } else {}
                //No collision


                //Return the collision string. it will be either "top", "right",
                //"bottom", or "left" depending on which side of r1 is touching r2.
            return collision;
        }

        /*
         hitTestRectangle
         ----------------
           Use it to find out if two rectangular sprites are touching.
         Parameters:
         a. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
         b. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
           */

    }, {
        key: "hitTestRectangle",
        value: function hitTestRectangle(r1, r2) {
            var global = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


            //Add collision properties
            if (!r1._bumpPropertiesAdded) this.addCollisionProperties(r1);
            if (!r2._bumpPropertiesAdded) this.addCollisionProperties(r2);

            var hit = void 0,
                combinedHalfWidths = void 0,
                combinedHalfHeights = void 0,
                vx = void 0,
                vy = void 0;

            //A variable to determine whether there's a collision
            hit = false;

            //Calculate the distance vector
            if (global) {
                vx = r1.gx + Math.abs(r1.halfWidth) - r1.xAnchorOffset - (r2.gx + Math.abs(r2.halfWidth) - r2.xAnchorOffset);
                vy = r1.gy + Math.abs(r1.halfHeight) - r1.yAnchorOffset - (r2.gy + Math.abs(r2.halfHeight) - r2.yAnchorOffset);
            } else {
                vx = r1.x + Math.abs(r1.halfWidth) - r1.xAnchorOffset - (r2.x + Math.abs(r2.halfWidth) - r2.xAnchorOffset);
                vy = r1.y + Math.abs(r1.halfHeight) - r1.yAnchorOffset - (r2.y + Math.abs(r2.halfHeight) - r2.yAnchorOffset);
            }

            //Figure out the combined half-widths and half-heights
            combinedHalfWidths = Math.abs(r1.halfWidth) + Math.abs(r2.halfWidth);
            combinedHalfHeights = Math.abs(r1.halfHeight) + Math.abs(r2.halfHeight);

            //Check for a collision on the x axis
            if (Math.abs(vx) < combinedHalfWidths) {

                //A collision might be occuring. Check for a collision on the y axis
                if (Math.abs(vy) < combinedHalfHeights) {

                    //There's definitely a collision happening
                    hit = true;
                } else {

                    //There's no collision on the y axis
                    hit = false;
                }
            } else {

                //There's no collision on the x axis
                hit = false;
            }

            //`hit` will be either `true` or `false`
            return hit;
        }

        /*
         hitTestCircleRectangle
         ----------------
           Use it to find out if a circular shape is touching a rectangular shape
         Parameters:
         a. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
         b. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
           */

    }, {
        key: "hitTestCircleRectangle",
        value: function hitTestCircleRectangle(c1, r1) {
            var global = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


            //Add collision properties
            if (!r1._bumpPropertiesAdded) this.addCollisionProperties(r1);
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);

            var region = void 0,
                collision = void 0,
                c1x = void 0,
                c1y = void 0,
                r1x = void 0,
                r1y = void 0;

            //Use either global or local coordinates
            if (global) {
                c1x = c1.gx;
                c1y = c1.gy;
                r1x = r1.gx;
                r1y = r1.gy;
            } else {
                c1x = c1.x;
                c1y = c1.y;
                r1x = r1.x;
                r1y = r1.y;
            }

            //Is the circle above the rectangle's top edge?
            if (c1y - c1.yAnchorOffset < r1y - Math.abs(r1.halfHeight) - r1.yAnchorOffset) {

                //If it is, we need to check whether it's in the
                //top left, top center or top right
                if (c1x - c1.xAnchorOffset < r1x - 1 - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                    region = "topLeft";
                } else if (c1x - c1.xAnchorOffset > r1x + 1 + Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                    region = "topRight";
                } else {
                    region = "topMiddle";
                }
            }

            //The circle isn't above the top edge, so it might be
            //below the bottom edge
            else if (c1y - c1.yAnchorOffset > r1y + Math.abs(r1.halfHeight) - r1.yAnchorOffset) {

                    //If it is, we need to check whether it's in the bottom left,
                    //bottom center, or bottom right
                    if (c1x - c1.xAnchorOffset < r1x - 1 - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                        region = "bottomLeft";
                    } else if (c1x - c1.xAnchorOffset > r1x + 1 + Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                        region = "bottomRight";
                    } else {
                        region = "bottomMiddle";
                    }
                }

                //The circle isn't above the top edge or below the bottom edge,
                //so it must be on the left or right side
                else {
                        if (c1x - c1.xAnchorOffset < r1x - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                            region = "leftMiddle";
                        } else {
                            region = "rightMiddle";
                        }
                    }

            //Is this the circle touching the flat sides
            //of the rectangle?
            if (region === "topMiddle" || region === "bottomMiddle" || region === "leftMiddle" || region === "rightMiddle") {

                //Yes, it is, so do a standard rectangle vs. rectangle collision test
                collision = this.hitTestRectangle(c1, r1, global);
            }

            //The circle is touching one of the corners, so do a
            //circle vs. point collision test
            else {
                    var point = {};

                    switch (region) {
                        case "topLeft":
                            point.x = r1x - r1.xAnchorOffset;
                            point.y = r1y - r1.yAnchorOffset;
                            break;

                        case "topRight":
                            point.x = r1x + r1.width - r1.xAnchorOffset;
                            point.y = r1y - r1.yAnchorOffset;
                            break;

                        case "bottomLeft":
                            point.x = r1x - r1.xAnchorOffset;
                            point.y = r1y + r1.height - r1.yAnchorOffset;
                            break;

                        case "bottomRight":
                            point.x = r1x + r1.width - r1.xAnchorOffset;
                            point.y = r1y + r1.height - r1.yAnchorOffset;
                    }

                    //Check for a collision between the circle and the point
                    collision = this.hitTestCirclePoint(c1, point, global);
                }

            //Return the result of the collision.
            //The return value will be `undefined` if there's no collision
            if (collision) {
                return region;
            } else {
                return collision;
            }
        }

        /*
         hitTestCirclePoint
         ------------------
           Use it to find out if a circular shape is touching a point
         Parameters:
         a. A sprite object with `centerX`, `centerY`, and `radius` properties.
         b. A point object with `x` and `y` properties.
           */

    }, {
        key: "hitTestCirclePoint",
        value: function hitTestCirclePoint(c1, point) {
            var global = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


            //Add collision properties
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);

            //A point is just a circle with a diameter of
            //1 pixel, so we can cheat. All we need to do is an ordinary circle vs. circle
            //Collision test. Just supply the point with the properties
            //it needs
            point.diameter = 1;
            point.width = point.diameter;
            point.radius = 0.5;
            point.centerX = point.x;
            point.centerY = point.y;
            point.gx = point.x;
            point.gy = point.y;
            point.xAnchorOffset = 0;
            point.yAnchorOffset = 0;
            point._bumpPropertiesAdded = true;
            return this.hitTestCircle(c1, point, global);
        }

        /*
         circleRectangleCollision
         ------------------------
           Use it to bounce a circular shape off a rectangular shape
         Parameters:
         a. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
         b. A sprite object with `centerX`, `centerY`, `halfWidth` and `halfHeight` properties.
           */

    }, {
        key: "circleRectangleCollision",
        value: function circleRectangleCollision(c1, r1) {
            var bounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var global = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


            //Add collision properties
            if (!r1._bumpPropertiesAdded) this.addCollisionProperties(r1);
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);

            var region = void 0,
                collision = void 0,
                c1x = void 0,
                c1y = void 0,
                r1x = void 0,
                r1y = void 0;

            //Use either the global or local coordinates
            if (global) {
                c1x = c1.gx;
                c1y = c1.gy;
                r1x = r1.gx;
                r1y = r1.gy;
            } else {
                c1x = c1.x;
                c1y = c1.y;
                r1x = r1.x;
                r1y = r1.y;
            }

            //Is the circle above the rectangle's top edge?
            if (c1y - c1.yAnchorOffset < r1y - Math.abs(r1.halfHeight) - r1.yAnchorOffset) {

                //If it is, we need to check whether it's in the
                //top left, top center or top right
                if (c1x - c1.xAnchorOffset < r1x - 1 - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                    region = "topLeft";
                } else if (c1x - c1.xAnchorOffset > r1x + 1 + Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                    region = "topRight";
                } else {
                    region = "topMiddle";
                }
            }

            //The circle isn't above the top edge, so it might be
            //below the bottom edge
            else if (c1y - c1.yAnchorOffset > r1y + Math.abs(r1.halfHeight) - r1.yAnchorOffset) {

                    //If it is, we need to check whether it's in the bottom left,
                    //bottom center, or bottom right
                    if (c1x - c1.xAnchorOffset < r1x - 1 - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                        region = "bottomLeft";
                    } else if (c1x - c1.xAnchorOffset > r1x + 1 + Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                        region = "bottomRight";
                    } else {
                        region = "bottomMiddle";
                    }
                }

                //The circle isn't above the top edge or below the bottom edge,
                //so it must be on the left or right side
                else {
                        if (c1x - c1.xAnchorOffset < r1x - Math.abs(r1.halfWidth) - r1.xAnchorOffset) {
                            region = "leftMiddle";
                        } else {
                            region = "rightMiddle";
                        }
                    }

            //Is this the circle touching the flat sides
            //of the rectangle?
            if (region === "topMiddle" || region === "bottomMiddle" || region === "leftMiddle" || region === "rightMiddle") {

                //Yes, it is, so do a standard rectangle vs. rectangle collision test
                collision = this.rectangleCollision(c1, r1, bounce, global);
            }

            //The circle is touching one of the corners, so do a
            //circle vs. point collision test
            else {
                    var point = {};

                    switch (region) {
                        case "topLeft":
                            point.x = r1x - r1.xAnchorOffset;
                            point.y = r1y - r1.yAnchorOffset;
                            break;

                        case "topRight":
                            point.x = r1x + r1.width - r1.xAnchorOffset;
                            point.y = r1y - r1.yAnchorOffset;
                            break;

                        case "bottomLeft":
                            point.x = r1x - r1.xAnchorOffset;
                            point.y = r1y + r1.height - r1.yAnchorOffset;
                            break;

                        case "bottomRight":
                            point.x = r1x + r1.width - r1.xAnchorOffset;
                            point.y = r1y + r1.height - r1.yAnchorOffset;
                    }

                    //Check for a collision between the circle and the point
                    collision = this.circlePointCollision(c1, point, bounce, global);
                }

            if (collision) {
                return region;
            } else {
                return collision;
            }
        }

        /*
         circlePointCollision
         --------------------
           Use it to boucnce a circle off a point.
         Parameters:
         a. A sprite object with `centerX`, `centerY`, and `radius` properties.
         b. A point object with `x` and `y` properties.
           */

    }, {
        key: "circlePointCollision",
        value: function circlePointCollision(c1, point) {
            var bounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var global = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


            //Add collision properties
            if (!c1._bumpPropertiesAdded) this.addCollisionProperties(c1);

            //A point is just a circle with a diameter of
            //1 pixel, so we can cheat. All we need to do is an ordinary circle vs. circle
            //Collision test. Just supply the point with the properties
            //it needs
            point.diameter = 1;
            point.width = point.diameter;
            point.radius = 0.5;
            point.centerX = point.x;
            point.centerY = point.y;
            point.gx = point.x;
            point.gy = point.y;
            point.xAnchorOffset = 0;
            point.yAnchorOffset = 0;
            point._bumpPropertiesAdded = true;
            return this.circleCollision(c1, point, bounce, global);
        }

        /*
         bounceOffSurface
         ----------------
           Use this to bounce an object off another object.
         Parameters:
         a. An object with `v.x` and `v.y` properties. This represents the object that is colliding
         with a surface.
         b. An object with `x` and `y` properties. This represents the surface that the object
         is colliding into.
         The first object can optionally have a mass property that's greater than 1. The mass will
         be used to dampen the bounce effect.
         */

    }, {
        key: "bounceOffSurface",
        value: function bounceOffSurface(o, s) {

            //Add collision properties
            if (!o._bumpPropertiesAdded) this.addCollisionProperties(o);

            var dp1 = void 0,
                dp2 = void 0,
                p1 = {},
                p2 = {},
                bounce = {},
                mass = o.mass || 1;

            //1. Calculate the collision surface's properties
            //Find the surface vector's left normal
            s.lx = s.y;
            s.ly = -s.x;

            //Find its magnitude
            s.magnitude = Math.sqrt(s.x * s.x + s.y * s.y);

            //Find its normalized values
            s.dx = s.x / s.magnitude;
            s.dy = s.y / s.magnitude;

            //2. Bounce the object (o) off the surface (s)

            //Find the dot product between the object and the surface
            dp1 = o.vx * s.dx + o.vy * s.dy;

            //Project the object's velocity onto the collision surface
            p1.vx = dp1 * s.dx;
            p1.vy = dp1 * s.dy;

            //Find the dot product of the object and the surface's left normal (s.lx and s.ly)
            dp2 = o.vx * (s.lx / s.magnitude) + o.vy * (s.ly / s.magnitude);

            //Project the object's velocity onto the surface's left normal
            p2.vx = dp2 * (s.lx / s.magnitude);
            p2.vy = dp2 * (s.ly / s.magnitude);

            //Reverse the projection on the surface's left normal
            p2.vx *= -1;
            p2.vy *= -1;

            //Add up the projections to create a new bounce vector
            bounce.x = p1.vx + p2.vx;
            bounce.y = p1.vy + p2.vy;

            //Assign the bounce vector to the object's velocity
            //with optional mass to dampen the effect
            o.vx = bounce.x / mass;
            o.vy = bounce.y / mass;
        }

        /*
         contain
         -------
         `contain` can be used to contain a sprite with `x` and
         `y` properties inside a rectangular area.
           The `contain` function takes four arguments: a sprite with `x` and `y`
         properties, an object literal with `x`, `y`, `width` and `height` properties. The
         third argument is a Boolean (true/false) value that determines if the sprite
         should bounce when it hits the edge of the container. The fourth argument
         is an extra user-defined callback function that you can call when the
         sprite hits the container
         ```js
         contain(anySprite, {x: 0, y: 0, width: 512, height: 512}, true, callbackFunction);
         ```
         The code above will contain the sprite's position inside the 512 by
         512 pixel area defined by the object. If the sprite hits the edges of
         the container, it will bounce. The `callBackFunction` will run if
         there's a collision.
           An additional feature of the `contain` method is that if the sprite
         has a `mass` property, it will be used to dampen the sprite's bounce
         in a natural looking way.
           If the sprite bumps into any of the containing object's boundaries,
         the `contain` function will return a value that tells you which side
         the sprite bumped into: �left�, �top�, �right� or �bottom�. Here's how
         you could keep the sprite contained and also find out which boundary
         it hit:
         ```js
         //Contain the sprite and find the collision value
         let collision = contain(anySprite, {x: 0, y: 0, width: 512, height: 512});
           //If there's a collision, display the boundary that the collision happened on
         if(collision) {
         if collision.has("left") console.log("The sprite hit the left");
         if collision.has("top") console.log("The sprite hit the top");
         if collision.has("right") console.log("The sprite hit the right");
         if collision.has("bottom") console.log("The sprite hit the bottom");
         }
         ```
         If the sprite doesn't hit a boundary, the value of
         `collision` will be `undefined`.
         */

        /*
         contain(sprite, container, bounce = false, extra = undefined) {
           //Helper methods that compensate for any possible shift the the
         //sprites' anchor points
         let nudgeAnchor = (o, value, axis) => {
         if (o.anchor !== undefined) {
         if (o.anchor[axis] !== 0) {
         return value * ((1 - o.anchor[axis]) - o.anchor[axis]);
         } else {
         return value;
         }
         } else {
         return value;
         }
         };
           let compensateForAnchor = (o, value, axis) => {
         if (o.anchor !== undefined) {
         if (o.anchor[axis] !== 0) {
         return value * o.anchor[axis];
         } else {
         return 0;
         }
         } else {
         return 0;
         }
         };
           let compensateForAnchors = (a, b, property1, property2) => {
         return compensateForAnchor(a, a[property1], property2) + compensateForAnchor(b, b[property1], property2)
         };
         //Create a set called `collision` to keep track of the
         //boundaries with which the sprite is colliding
         let collision = new Set();
           //Left
         if (sprite.x - compensateForAnchor(sprite, sprite.width, "x") < container.x - sprite.parent.gx - compensateForAnchor(container, container.width, "x")) {
         //Bounce the sprite if `bounce` is true
         if (bounce) sprite.vx *= -1;
           //If the sprite has `mass`, let the mass
         //affect the sprite's velocity
         if(sprite.mass) sprite.vx /= sprite.mass;
           //Keep the sprite inside the container
         sprite.x = container.x - sprite.parent.gx + compensateForAnchor(sprite, sprite.width, "x") - compensateForAnchor(container, container.width, "x");
           //Add "left" to the collision set
         collision.add("left");
         }
           //Top
         if (sprite.y - compensateForAnchor(sprite, sprite.height, "y") < container.y - sprite.parent.gy - compensateForAnchor(container, container.height, "y")) {
         if (bounce) sprite.vy *= -1;
         if(sprite.mass) sprite.vy /= sprite.mass;
         sprite.y = container.x - sprite.parent.gy + compensateForAnchor(sprite, sprite.height, "y") - compensateForAnchor(container, container.height, "y");
         collision.add("top");
         }
           //Right
         if (sprite.x - compensateForAnchor(sprite, sprite.width, "x") + sprite.width > container.width - compensateForAnchor(container, container.width, "x")) {
         if (bounce) sprite.vx *= -1;
         if(sprite.mass) sprite.vx /= sprite.mass;
         sprite.x = container.width - sprite.width + compensateForAnchor(sprite, sprite.width, "x") - compensateForAnchor(container, container.width, "x");
         collision.add("right");
         }
           //Bottom
         if (sprite.y - compensateForAnchor(sprite, sprite.height, "y") + sprite.height > container.height - compensateForAnchor(container, container.height, "y")) {
         if (bounce) sprite.vy *= -1;
         if(sprite.mass) sprite.vy /= sprite.mass;
         sprite.y = container.height - sprite.height + compensateForAnchor(sprite, sprite.height, "y") - compensateForAnchor(container, container.height, "y");
         collision.add("bottom");
         }
           //If there were no collisions, set `collision` to `undefined`
         if (collision.size === 0) collision = undefined;
           //The `extra` function runs if there was a collision
         //and `extra` has been defined
         if (collision && extra) extra(collision);
           //Return the `collision` value
         return collision;
         }
         */

    }, {
        key: "contain",
        value: function contain(sprite, container) {
            var bounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;


            //Add collision properties
            if (!sprite._bumpPropertiesAdded) this.addCollisionProperties(sprite);

            //Give the container x and y anchor offset values, if it doesn't
            //have any
            if (container.xAnchorOffset === undefined) container.xAnchorOffset = 0;
            if (container.yAnchorOffset === undefined) container.yAnchorOffset = 0;
            if (sprite.parent.gx === undefined) sprite.parent.gx = 0;
            if (sprite.parent.gy === undefined) sprite.parent.gy = 0;

            //Create a Set called `collision` to keep track of the
            //boundaries with which the sprite is colliding
            var collision = new Set();

            //Left
            if (sprite.x - sprite.xAnchorOffset < container.x - sprite.parent.gx - container.xAnchorOffset) {

                //Bounce the sprite if `bounce` is true
                if (bounce) sprite.vx *= -1;

                //If the sprite has `mass`, let the mass
                //affect the sprite's velocity
                if (sprite.mass) sprite.vx /= sprite.mass;

                //Reposition the sprite inside the container
                sprite.x = container.x - sprite.parent.gx - container.xAnchorOffset + sprite.xAnchorOffset;

                //Make a record of the side which the container hit
                collision.add("left");
            }

            //Top
            if (sprite.y - sprite.yAnchorOffset < container.y - sprite.parent.gy - container.yAnchorOffset) {
                if (bounce) sprite.vy *= -1;
                if (sprite.mass) sprite.vy /= sprite.mass;
                sprite.y = container.y - sprite.parent.gy - container.yAnchorOffset + sprite.yAnchorOffset;
                ;
                collision.add("top");
            }

            //Right
            if (sprite.x - sprite.xAnchorOffset + sprite.width > container.width - container.xAnchorOffset) {
                if (bounce) sprite.vx *= -1;
                if (sprite.mass) sprite.vx /= sprite.mass;
                sprite.x = container.width - sprite.width - container.xAnchorOffset + sprite.xAnchorOffset;
                collision.add("right");
            }

            //Bottom
            if (sprite.y - sprite.yAnchorOffset + sprite.height > container.height - container.yAnchorOffset) {
                if (bounce) sprite.vy *= -1;
                if (sprite.mass) sprite.vy /= sprite.mass;
                sprite.y = container.height - sprite.height - container.yAnchorOffset + sprite.yAnchorOffset;
                collision.add("bottom");
            }

            //If there were no collisions, set `collision` to `undefined`
            if (collision.size === 0) collision = undefined;

            //The `extra` function runs if there was a collision
            //and `extra` has been defined
            if (collision && extra) extra(collision);

            //Return the `collision` value
            return collision;
        }

        //`outsideBounds` checks whether a sprite is outide the boundary of
        //another object. It returns an object called `collision`. `collision` will be `undefined` if there's no
        //collision. But if there is a collision, `collision` will be
        //returned as a Set containg strings that tell you which boundary
        //side was crossed: "left", "right", "top" or "bottom"

    }, {
        key: "outsideBounds",
        value: function outsideBounds(s, bounds, extra) {

            var x = bounds.x,
                y = bounds.y,
                width = bounds.width,
                height = bounds.height;

            //The `collision` object is used to store which
            //side of the containing rectangle the sprite hits
            var collision = new Set();

            //Left
            if (s.x < x - s.width) {
                collision.add("left");
            }
            //Top
            if (s.y < y - s.height) {
                collision.add("top");
            }
            //Right
            if (s.x > width + s.width) {
                collision.add("right");
            }
            //Bottom
            if (s.y > height + s.height) {
                collision.add("bottom");
            }

            //If there were no collisions, set `collision` to `undefined`
            if (collision.size === 0) collision = undefined;

            //The `extra` function runs if there was a collision
            //and `extra` has been defined
            if (collision && extra) extra(collision);

            //Return the `collision` object
            return collision;
        }

        /*
         _getCenter
         ----------
           A utility that finds the center point of the sprite. If it's anchor point is the
         sprite's top left corner, then the center is calculated from that point.
         If the anchor point has been shifted, then the anchor x/y point is used as the sprite's center
         */

    }, {
        key: "_getCenter",
        value: function _getCenter(o, dimension, axis) {
            if (o.anchor !== undefined) {
                if (o.anchor[axis] !== 0) {
                    return 0;
                } else {
                    //console.log(o.anchor[axis])
                    return dimension / 2;
                }
            } else {
                return dimension;
            }
        }

        /*
         hit
         ---
         A convenient universal collision function to test for collisions
         between rectangles, circles, and points.
         */

    }, {
        key: "hit",
        value: function hit(a, b) {
            var react = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var bounce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var global = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var extra = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;


            //Local references to bump's collision methods
            var hitTestPoint = this.hitTestPoint.bind(this),
                hitTestRectangle = this.hitTestRectangle.bind(this),
                hitTestCircle = this.hitTestCircle.bind(this),
                movingCircleCollision = this.movingCircleCollision.bind(this),
                circleCollision = this.circleCollision.bind(this),
                hitTestCircleRectangle = this.hitTestCircleRectangle.bind(this),
                rectangleCollision = this.rectangleCollision.bind(this),
                circleRectangleCollision = this.circleRectangleCollision.bind(this);

            var collision = void 0,
                aIsASprite = a.parent !== undefined,
                bIsASprite = b.parent !== undefined;

            //Check to make sure one of the arguments isn't an array
            if (aIsASprite && b instanceof Array || bIsASprite && a instanceof Array) {
                //If it is, check for a collision between a sprite and an array
                spriteVsArray();
            } else {
                //If one of the arguments isn't an array, find out what type of
                //collision check to run
                collision = findCollisionType(a, b);
                if (collision && extra) extra(collision);
            }

            //Return the result of the collision.
            //It will be `undefined` if there's no collision and `true` if
            //there is a collision. `rectangleCollision` sets `collsision` to
            //"top", "bottom", "left" or "right" depeneding on which side the
            //collision is occuring on
            return collision;

            function findCollisionType(a, b) {
                //Are `a` and `b` both sprites?
                //(We have to check again if this function was called from
                //`spriteVsArray`)
                var aIsASprite = a.parent !== undefined;
                var bIsASprite = b.parent !== undefined;

                if (aIsASprite && bIsASprite) {
                    //Yes, but what kind of sprites?
                    if (a.diameter && b.diameter) {
                        //They're circles
                        return circleVsCircle(a, b);
                    } else if (a.diameter && !b.diameter) {
                        //The first one is a circle and the second is a rectangle
                        return circleVsRectangle(a, b);
                    } else {
                        //They're rectangles
                        return rectangleVsRectangle(a, b);
                    }
                }
                //They're not both sprites, so what are they?
                //Is `a` not a sprite and does it have x and y properties?
                else if (bIsASprite && !(a.x === undefined) && !(a.y === undefined)) {
                        //Yes, so this is a point vs. sprite collision test
                        return hitTestPoint(a, b);
                    } else {
                        //The user is trying to test some incompatible objects
                        throw new Error("I'm sorry, " + a + " and " + b + " cannot be use together in a collision test.'");
                    }
            }

            function spriteVsArray() {
                //If `a` happens to be the array, flip it around so that it becomes `b`
                if (a instanceof Array) {
                    var _ref = [_b, _a],
                        _a = _ref[0],
                        _b = _ref[1];
                }
                //Loop through the array in reverse
                for (var i = b.length - 1; i >= 0; i--) {
                    var sprite = b[i];
                    collision = findCollisionType(a, sprite);
                    if (collision && extra) extra(collision, sprite);
                }
            }

            function circleVsCircle(a, b) {
                //If the circles shouldn't react to the collision,
                //just test to see if they're touching
                if (!react) {
                    return hitTestCircle(a, b);
                }
                //Yes, the circles should react to the collision
                else {
                        //Are they both moving?
                        if (a.vx + a.vy !== 0 && b.vx + b.vy !== 0) {
                            //Yes, they are both moving
                            //(moving circle collisions always bounce apart so there's
                            //no need for the third, `bounce`, argument)
                            return movingCircleCollision(a, b, global);
                        } else {
                            //No, they're not both moving
                            return circleCollision(a, b, bounce, global);
                        }
                    }
            }

            function rectangleVsRectangle(a, b) {
                //If the rectangles shouldn't react to the collision, just
                //test to see if they're touching
                if (!react) {
                    return hitTestRectangle(a, b, global);
                } else {
                    return rectangleCollision(a, b, bounce, global);
                }
            }

            function circleVsRectangle(a, b) {
                //If the rectangles shouldn't react to the collision, just
                //test to see if they're touching
                if (!react) {
                    return hitTestCircleRectangle(a, b, global);
                } else {
                    return circleRectangleCollision(a, b, bounce, global);
                }
            }
        }
    }]);

    return Bump;
}();

exports.default = Bump;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Common() {}
exports.default = Common;

//====================================//
//=====PROJECT SPECIFIC VARIABLES=====//
//====================================//

Common.bump = null;

Common.results = null;
Common.yourCharacter = null;

/**
 * @type {PIXI.Container}
 */
Common.uiHolder = null;

/**
 * @type {Array}
 */
Common.greyCircleTextures = [];
Common.whiteCircleTextures = [];
Common.resultList = [];
Common.questionList = [];

/**
 * @type {Array}
 */
Common.generatedButtonTextures = [];

/**
 * @type {function}
 */
Common.cleanupButtons = function () {
    var len = Common.generatedButtonTextures.length;
    for (var i = 0; i < len; i++) {
        Common.generatedButtonTextures[i].destroy(true);
        Common.generatedButtonTextures[i] = null;
    }
    Common.generatedButtonTextures.length = 0;
};

/**
 * @param arr
 */
Common.buttonsAppear = function (arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            delay: i * 0.15 + 0.25
        });
    }
};

//====================================//
//========PROJECT SPECIFIC END========//
//====================================//

/**
 * Simple pixi compatible collision detection etc
 * @type {null}
 */
Common.bump = null;

/**
 * @type {null|P3.AssetManager}
 */
Common.assets = null;

/**
 * @type {P3.View}
 */
Common.view = null;

/**
 * @type {number}
 */
Common.paused = false;

/**
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 */
Common.isDebug = false;

//===============//
//==static vars==//
//===============//

/**
 * Semi unique key used as an identifier for save files, followed by company code and the version
 * (useful if you want players to start a new game, increment version number)
 * @constant @static
 * @type {string}
 */
Common.game_key = "5ft272jq-PZN_v1-02";

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {P3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @type {boolean}
 * @static
 */
Common.tabActive = false;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_WIDTH = 1900;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_HEIGHT = 768;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

//===============//
//==static ends==//
//===============//

//================================//
//=====save and load functions====//
//================================//

Common.saveMute = function () {
    var data = { isMute: Common.audio.isMute };
    localStorage.setItem(Common.game_key + "_isMute", JSON.stringify(data));
};

Common.loadMute = function () {
    var data = JSON.parse(localStorage.getItem(Common.game_key + "_isMute"));
    if (data) Common.audio.mute(data.isMute);
};

Common.saveGame = function () {
    var gameData = {
        completed: Common.completed,
        shownExitPanel: Common.shownExitPanel
    };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    Common.completed = [0, 0, 0]; //init to -1, set to 0 for not complete on load
    var gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.completed = gameData.completed;
        Common.shownExitPanel = gameData.shownExitPanel;
        Common.isFirstPlay = false;
    } else {
        Common.isFirstPlay = true;
    }
};

//=========================================================//
//=============Rest is all util type functions=============//
//=========================================================//

/**
 * Knuth shuffle variant
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    var a = string.split(""); //our array
    var n = a.length; //number of elements
    for (var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = function (a) {
    for (var i = a.length; i; i--) {
        var j = Math.floor(Math.random() * i);
        var _ref = [a[j], a[i - 1]];
        a[i - 1] = _ref[0];
        a[j] = _ref[1];
    }
    return a;
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    strLen = strLen || 8;
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    return Math.atan2(dy, dx);
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

/**
 * @param rad
 * @returns {number}
 */
Common.rad2deg = function (rad) {
    return rad * 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * @deprecated
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (var i = 0; i < arguments.length; i++) {
        arguments[i].anchor.set(0.5);
    }
};

/**
 * @deprecated
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    var arr = [];
    for (var i = 0; i < numRows; i++) {
        var columns = [];
        for (var j = 0; j < numCols; j++) {
            columns[j] = initial;
        }arr[i] = columns;
    }
    return arr;
};

/**
 * @deprecated
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    var arr = [];
    for (var i = 0; i < size; i++) {
        arr.push(initial);
    }return arr;
};

Common.compareXY = function (point1, point2) {
    return Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y);
};

Common.lerpAxis = function (start, end, percent) {
    return (end - start) * percent + start;
};

Common.lerpVector = function (start, end, percent) {
    return Common.Vector.add(Common.Vector.scale(Common.Vector.sub(start, end), percent), start);
};

Common.Vector = {
    add: function add(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector#add must be passed a pair of vectors');
        return { x: a.x + b.x, y: a.y + b.y };
    },
    sub: function sub(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector#sub must be passed a pair of vectors');
        return { x: a.x - b.x, y: a.y - b.y };
    },
    mult: function mult(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector#mult must be passed a pair of vectors');
        return { x: a.x * b.x, y: a.y * b.y };
    },
    div: function div(a, b) {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector#div must be passed a pair of vectors');
        return { x: a.x / b.x, y: a.y / b.y };
    },
    scale: function scale(a, scalePerc) {
        if (a.x === undefined) throw new Error('Vector#scale must be passed a vector for first arg');
        return { x: a.x * scalePerc, y: a.y * scalePerc };
    }
};

Common.lookAt = function (sprite, target, update) {
    var rotation = Math.atan2(target.y - sprite.y, target.x - sprite.x);
    if (update) sprite.rotation = rotation;
    return rotation;
};

//--from stackoverflow-- https://stackoverflow.com/questions/14962018/detecting-and-fixing-circular-references-in-javascript //
Common.detectCircularRef = function (obj) {

    return detectCircularReferences(obj);

    function detectCircularReferences(toBeStringifiedValue) {
        var serializationKeyStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        Object.keys(toBeStringifiedValue).forEach(function (key) {
            var value = toBeStringifiedValue[key];
            var serializationKeyStackWithNewKey = serializationKeyStack.slice();
            serializationKeyStackWithNewKey.push(key);
            try {
                JSON.stringify(value);
            } catch (error) {
                var isCircularValue;
                var circularExcludingStringifyResult = "";
                try {
                    circularExcludingStringifyResult = JSON.stringify(value, replaceRootStringifyReplacer(value), 2);
                    isCircularValue = true;
                } catch (error) {
                    detectCircularReferences(value, serializationKeyStackWithNewKey);
                    isCircularValue = false;
                }
                if (isCircularValue) {
                    throw new Error("Circular reference detected:\nCircularly referenced value is value under path \"" + joinStrings(serializationKeyStackWithNewKey) + "\" of the given root object\n" + ("Calling stringify on this value but replacing itself with [Circular object --- fix me] ( <-- search for this string) results in:\n" + circularExcludingStringifyResult + "\n"));
                }
            }
        });
    }

    function replaceRootStringifyReplacer(toBeStringifiedValue) {
        var serializedObjectCounter = 0;
        return function (key, value) {
            if (serializedObjectCounter !== 0 && (typeof toBeStringifiedValue === "undefined" ? "undefined" : _typeof(toBeStringifiedValue)) === 'object' && toBeStringifiedValue === value) {
                return '[Circular object --- fix me]';
            }
            serializedObjectCounter++;
            return value;
        };
    }

    function joinStrings(arr) {
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";

        if (arr.length === 0) return "";
        return arr.reduce(function (v1, v2) {
            return "" + v1 + separator + v2;
        });
    }
};

//from github pixi-simple-gestures
Common.pinchable = function (sprite, inertia) {

    sprite.interactive = true;
    sprite.on('touchstart', start);
    sprite.on('touchend', end);
    sprite.on('touchendoutside', end);

    function start(e) {
        sprite.on('touchmove', move);
    }

    function move(e) {
        var t = e.data.originalEvent.targetTouches;
        if (!t || t.length < 2) {
            return;
        }
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (!sprite._pinch) {
            sprite._pinch = {
                p: {
                    distance: distance,
                    date: new Date()
                }
            };
            sprite.emit('pinchstart');
            return;
        }
        var now = new Date();
        var interval = now - sprite._pinch.p.date;
        if (interval < 12) {
            return;
        }
        var center = {
            x: (t[0].clientX + t[1].clientX) / 2,
            y: (t[0].clientY + t[1].clientY) / 2
        };
        var event = {
            scale: distance / sprite._pinch.p.distance,
            velocity: distance / interval,
            center: center,
            data: e.data
        };
        sprite.emit('pinchmove', event);
        sprite._pinch.pp = {
            distance: sprite._pinch.p.distance,
            date: sprite._pinch.p.date
        };
        sprite._pinch.p = {
            distance: distance,
            date: now
        };
    }

    function end(e) {
        sprite.removeListener('touchmove', move);
        if (!sprite._pinch) {
            return;
        }
        if (inertia && sprite._pinch.pp) {
            if (sprite._pinch.intervalId) {
                return;
            }
            var interval = new Date() - sprite._pinch.p.date;
            var velocity = (sprite._pinch.p.distance - sprite._pinch.pp.distance) / interval;
            var center = sprite._pinch.p.center;
            var distance = sprite._pinch.p.distance;
            sprite._pinch.intervalId = setInterval(function () {
                if (Math.abs(velocity) < 0.04) {
                    clearInterval(sprite._pinch.intervalId);
                    sprite.emit('pinchend');
                    sprite._pinch = null;
                    return;
                }
                var updatedDistance = distance + velocity * 12;
                var event = {
                    scale: updatedDistance / distance,
                    velocity: velocity,
                    center: center,
                    data: e.data
                };
                sprite.emit('pinchmove', event);
                distance = updatedDistance;
                velocity *= 0.8;
            }, 12);
        } else {
            sprite.emit('pinchend');
            sprite._pinch = null;
        }
    }
};

//from https://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
Common.getAndroidVersion = function (ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

/**
 * Custom tween
 * @param obj
 * @param time
 * @param params
 * @returns {TweenLite|TweenMax|TimelineLite|*}
 */
Common.erraticTween = function (obj, time) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { delay: 0 };

    params.ease = CustomEase.create("custom", "M0,0,C0,0,0.065,0.167,0.08,0.205,0.09,0.2,0.124,0.182,0.135,0.176,0.157,0.223,0.21,0.59,0.22,0.608,0.223,0.585,0.298,0.12,0.3,0.111,0.3,0.118,0.309,0.262,0.315,0.345,0.322,0.36,0.325,0.372,0.335,0.388,0.352,0.417,0.372,0.439,0.39,0.463,0.391,0.502,0.394,0.58,0.395,0.583,0.396,0.578,0.418,0.461,0.43,0.399,0.431,0.397,0.463,0.611,0.464,0.61,0.475,0.621,0.488,0.448,0.495,0.455,0.495,0.449,0.498,0.417,0.5,0.404,0.512,0.401,0.562,0.262,0.572,0.26,0.577,0.293,0.568,0.499,0.58,0.568,0.597,0.639,0.603,0.787,0.608,0.806,0.616,0.794,0.698,0.64,0.705,0.63,0.705,0.638,0.708,0.685,0.71,0.72,0.711,0.734,0.713,0.745,0.715,0.756,0.719,0.759,0.737,0.781,0.742,0.784,0.746,0.83,0.743,0.912,0.745,0.925,0.756,0.907,0.863,0.732,0.88,0.705,0.894,0.741,1,1,1,1");
    return TweenMax.to(obj, time, params);
};

/**
 * Dijkstra implementation of a path finder. Prefer this over A* if you have multiple agents with same starting position
 * and you are using a weighted graph. For non weighted graphics use BFS. For a single agent with a known single target destination use A*.
 * Or alternatively if you are unsure what your target is you can calc the path to all nodes, and then just retrieve the path to the target
 * node once you know it which could be useful depending on use case.
 *
 * @class
 */

var Dijkstra = function () {
    function Dijkstra() {
        _classCallCheck(this, Dijkstra);

        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        //todo - add findPath() function which terminates when u === v
        /**
         * @type {null}
         * @private
         */
        this._target = null; //note we may want to target if we only have one agent, but A* is probably better for this case so prefer that if you don't need to guarantee the shortest path

        /**
         * Vertex set Q
         * @type {Array}
         * @private
         */
        this._verts = [];

        /**
         * @type {null}
         * @private
         */
        this._paths = null;
    }

    _createClass(Dijkstra, [{
        key: "init",
        value: function init() {

            if (!this._graph) throw new Error('must set graph before init');
            if (!this._source) throw new Error('must set source before init');

            //--create vertex set Q--//
            for (var x = 0; x < this._graph.length; x++) {
                for (var y = 0; y < this._graph[x].length; y++) {
                    // All nodes initially in Q (unvisited nodes)
                    var vert = this._graph[x][y];

                    vert.distance = Number.POSITIVE_INFINITY;
                    vert.prev = null;
                    vert.neighbours = [];

                    if (x > 0) vert.neighbours.push(this._graph[x - 1][y]); //grid sq left
                    if (x < this._graph.length - 1) vert.neighbours.push(this._graph[x + 1][y]); //grid sq right
                    if (y > 0) vert.neighbours.push(this._graph[x][y - 1]); //grid sq above
                    if (y < this._graph[x].length - 1) vert.neighbours.push(this._graph[x][y + 1]); //grid sq below

                    this._verts.push(vert);
                }
            }
            var s = this._source;
            this._verts[this._graph.length * s.x + s.y].distance = 0; //set source to source distance as zero (ensures this is first in our list becaue it has the lowest dist)
        }
    }, {
        key: "findPaths",
        value: function findPaths() {

            var descending = function descending(a, b) {
                return b.distance - a.distance;
            }; //descending sort function

            var paths = [];

            while (this._verts.length > 0) {

                //--find node with least dist by sorting--//
                // this._verts = Common.sortDistances(this._verts, true);   //highToLow
                this._verts.sort(descending); //way outperforms my quick sort function (100 to 300 percent quicker)

                var u = this._verts[this._verts.length - 1]; //take last element which is the one with the shortest distance

                this._verts.pop(); //remove u from vert list (Q)

                //--for each neighbour v of u--//
                for (var i = 0; i < u.neighbours.length; i++) {
                    var v = u.neighbours[i];
                    var sourceToV = u.distance + Dijkstra.distance(u.x, u.y, v.x, v.y);
                    if (sourceToV < v.distance) {
                        //we found a new shortest distance to this node v
                        v.distance = sourceToV; //store dist
                        v.prev = u; //store prev node

                        paths.push(v);
                    }
                }
            }

            this._paths = paths;

            return paths;
        }

        /**
         * Fetches the path from the this._paths pre calculated paths to all nodes
         * @param pos
         */

    }, {
        key: "retrievePathTo",
        value: function retrievePathTo(pos) {
            var node = void 0;
            for (var i = 0; i < this._paths.length; i++) {
                if (Dijkstra.compareXY(pos, this._paths[i])) {
                    node = this._paths[i];
                }
            }

            if (!node) {
                throw new Error("can't retrieve path, position not on graph");
            }

            var path = [];

            //--trace back to start node to create the path--//
            var recurse = function recurse() {
                //using a little recursive function to trace the path backwards
                path.push({ x: node.x, y: node.y });
                if (node.prev) {
                    node = node.prev;
                    recurse();
                }
            };
            recurse();

            return path;
        }
    }, {
        key: "reset",
        value: function reset() {
            this.init();
        }
    }, {
        key: "test",
        value: function test(scene) {

            var tWid = 50;
            var holder = new PIXI.Container();
            var gridSize = 15;
            var graph = Dijkstra.matrix(gridSize, gridSize);
            holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
            scene.addChild(holder);

            for (var x = 0; x < gridSize; x++) {
                for (var y = 0; y < gridSize; y++) {

                    var _sp = new PIXI.Sprite(PIXI.Texture.WHITE);
                    holder.addChild(_sp);
                    _sp.x = x * tWid;
                    _sp.y = y * tWid;

                    _sp.width = tWid - 2;
                    _sp.height = tWid - 2;

                    _sp.tint = 0xD8D8D8;

                    graph[x][y] = { x: x, y: y }; //grid should be stored as int and we will multiply out to get tile pos
                }
            }

            this.graph = graph;
            this.source = graph[0][0]; //set source to be top left

            var t0 = performance.now();
            this.init();
            var paths = this.findPaths();
            var t1 = performance.now();
            console.warn("found paths in : " + (t1 - t0));

            var path = this.retrievePathTo({ x: gridSize - 1, y: gridSize - 1 }); //retrieve path to bottom right

            console.log(paths);
            console.log(path);

            //--create a sprite and put it in top left corner of graph--//
            var sp = new PIXI.Sprite(PIXI.Texture.WHITE);
            holder.addChild(sp);
            sp.anchor.set(0.5);
            sp.position.set(graph[0][0].x, graph[0][0].y);
            sp.width = tWid * 0.5;
            sp.height = tWid * 0.5;

            followPath(sp, tWid, path);

            /**
             * Simple recursive function that tests the path by tweening the sprite along it
             * @param sprite
             * @param tWid
             * @param path
             */
            function followPath(sprite, tWid, path) {
                var node = path[path.length - 1];
                TweenMax.to(sprite, 0.5, {
                    x: node.x * tWid,
                    y: node.y * tWid + tWid * 0.5,
                    ease: Power0.easeNone,
                    onComplete: function onComplete() {
                        path.pop();
                        if (path.length > 0) followPath(sprite, tWid, path);
                    }
                });
            }
        }
    }, {
        key: "graph",
        set: function set(value) {
            this._graph = value;
        }
    }, {
        key: "source",
        set: function set(value) {
            this._source = value;
        }
    }, {
        key: "target",
        set: function set(value) {
            this._target = value;
        }
    }], [{
        key: "compareXY",
        value: function compareXY(point1, point2) {
            return Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y);
        }
    }, {
        key: "matrix",
        value: function matrix(numRows, numCols, initial) {
            var arr = [];
            for (var i = 0; i < numRows; i++) {
                var columns = [];
                for (var j = 0; j < numCols; j++) {
                    columns[j] = initial;
                }arr[i] = columns;
            }
            return arr;
        }
    }]);

    return Dijkstra;
}();

Common.PathD = new Dijkstra();

window.Common = Common;

},{"./Application":2}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Main
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 19/9/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _GenericPreloaderScene = require("./../scenes/GenericPreloaderScene");

var _GenericPreloaderScene2 = _interopRequireDefault(_GenericPreloaderScene);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Bump = require("./Bump");

var _Bump2 = _interopRequireDefault(_Bump);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 */
var Main = function () {
    /**
     * @param {number} width
     * @param {number} height
     */
    function Main(width, height) {
        _classCallCheck(this, Main);

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {GenericPreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    _createClass(Main, [{
        key: "init",
        value: function init() {

            var bump = new _Bump2.default(PIXI);
            _Common2.default.bump = bump;

            var audio = new P3.AudioManager();
            _Common2.default.audio = P3.Button.audio = audio;

            var assets = new P3.AssetManager();
            assets.signals.audioFile.add(audio.addSound, audio);
            _Common2.default.assets = assets;

            _Common2.default.language = language;
            _Common2.default.tabActive = true;

            PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
            //PIXI.settings.MIPMAP_TEXTURES = false;

            TweenMax.defaultOverwrite = "none";
            TweenLite.lagSmoothing();

            var options = {
                width: this._width,
                height: this._height,
                holderId: "game",
                portrait: false,
                rotateImageUrl: "assets/images/rotate.jpg",
                rotateImageColor: "#000000",
                aspectRatioFillHeight: true
            };

            var view = new P3.View(options);
            view.signals.ready.addOnce(function (canvas) {
                var options = {};
                options.view = canvas;
                options.transparent = false;
                options.antialias = true;
                options.preserveDrawingBuffer = false;
                options.resolution = 1;

                var stage = new PIXI.Container();
                _Common2.default.stage = stage;

                var input = new P3.Input();
                input.init(stage, canvas);
                _Common2.default.input = input;

                /*
                 //on clicking the document focus on canvas, fix for buttons not working on mobile
                 document.onclick = () => {
                 canvas.focus();
                 };
                 */

                if (P3.utils.isCocoonJS()) {
                    stage.scale.x = window.innerHeight / this._height;
                    stage.scale.y = window.innerHeight / this._height;
                    console.log(stage.scale.x, stage.scale.y, window.innerWidth, window.innerHeight);
                }

                var renderer = new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
                //const renderer = !P3.utils.isCocoonJS() ?
                //   PIXI.autoDetectRenderer(this._width, this._height, options) :
                //  new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
                renderer.backgroundColor = 0xf7f7f7;
                _Common2.default.renderer = renderer;
                _Common2.default.isWebGL = renderer instanceof PIXI.WebGLRenderer;

                var scene = new P3.SceneManager(renderer);
                _Common2.default.scene = scene;
                _Common2.default.stage.addChild(scene.view);

                var ticker = new P3.Ticker();
                ticker.init(function () {
                    scene.update();
                    input.update();
                    window.deltaTime = P3.Ticker.dt;
                }, function () {
                    renderer.render(_Common2.default.stage);
                });

                window.delay = function (callback, delay, scope) {
                    return TweenMax.delayedCall(delay, callback, [], scope);
                };
                window.delayarg = function (callback, delay, args, scope) {
                    return TweenMax.delayedCall(delay, callback, args, scope);
                };
                window.translate = function (str) {
                    var s = _Common2.default.config.strings[str];
                    s = s && s[_Common2.default.language];
                    return typeof s !== "undefined" ? s : str;
                };

                this.loadPreloader();
            }, this);
            view.signals.resize.add(this.onCanvasResize, this);
            view.init();
            _Common2.default.view = view;
        }
    }, {
        key: "loadPreloader",
        value: function loadPreloader() {
            var files = [
                // {name: "preloader", url: "images/" + "preloader" + ".json"}
            ];

            if (files.length) {
                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.complete.addOnce(function () {
                    Main.createConfig();
                    this.loadAssets();
                }, this);
                _Common2.default.assets.load();
            } else {
                this.loadAssets();
            }
        }
    }, {
        key: "loadAssets",
        value: function loadAssets() {
            var _this = this;

            var ext = P3.AssetManager.AUDIO_FILE_EXTENSION;

            var files = [{ name: "dirt_strip", url: "images/" + "dirt_strip" + ".png" }, { name: "dirt_top", url: "images/" + "dirt_top" + ".png" }, { name: "knight", url: "images/" + "knight" + ".png" }, { name: "cube", url: "images/" + "cube" + ".png" }, { name: "chr_sliced", url: "images/" + "chr_sliced" + ".png" }, { name: "tank", url: "images/" + "tank" + ".png" }, { name: "house", url: "images/" + "obj_house1" + ".png" }, { name: "tree", url: "images/" + "tree3" + ".png" }, { name: "grass", url: "images/" + "grass" + ".jpg" },
            //--bg--//
            //   {name: "bg", url: "images/" + "bg_environment_01_1x" + ".png"},
            //  {name: "char_mask", url: "images/" + "char_mask" + ".png"},
            //--sheets--//
            //  {name: "dna_elements_1x", url: "images/" + "dna_elements_1x" + ".json"},
            //  {name: "dna_char_rapunzel_1x", url: "images/" + "dna_char_rapunzel_1x" + ".json"},
            //{name: "ui_buttons_1x", url: "images/" + "ui_buttons_1x" + ".json"},
            //--spine--//
            //  {name: "mickey_dna_seq_01", url: "images/" + "mickey_dna_seq_01" + ".json"},
            //--data--//
            { name: "config", url: "data/" + "config" + ".json"
                //--sounds--//
                //     {name: "sfx_btn_down_01", url: "audio/" + "sfx_btn_down_01" + ext},
                //    {name: "sfx_btn_over_01", url: "audio/" + "sfx_btn_over_01" + ext}
            }];

            for (var i = 1; i <= 12; i++) {
                var obj = { name: "iso_" + i, url: "images/" + "iso_" + i + ".png" };
                files.push(obj);
            }

            if (files.length) {

                //--fix for text not being loaded, create some text then wait a little before starting preloader--..
                var txt = new PIXI.Text("", { size: 1, fontFamily: "Noto Sans" });
                _Common2.default.stage.addChild(txt);

                delay(function () {
                    _Common2.default.stage.removeChild(txt);
                    txt.destroy();

                    _this._preloader = new _GenericPreloaderScene2.default();
                    _Common2.default.scene.add(_this._preloader);

                    _Common2.default.assets.addFiles(files, "assets/");
                    _Common2.default.assets.signals.progress.add(_this.onLoadingProgress, _this);
                    _Common2.default.assets.signals.complete.addOnce(_this.onLoadingCompleted, _this);
                    _Common2.default.assets.load();
                }, 0.2);
            } else {
                this.startGame();
            }
        }
    }, {
        key: "startGame",


        /**
         * @param [t=0]
         */
        value: function startGame() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            delay(function () {
                this._game = new _Application2.default();
                this._game.init();
            }, t, this);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            this._preloader.loaded = event.progress / 100.0;
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            var _this2 = this;

            _Common2.default.assets.signals.progress.removeAll();
            _Common2.default.assets.signals.complete.removeAll();

            this._preloader.loaded = 1;

            this._preloader.onLoadComplete();

            this._preloader.signals.next.add(function () {
                return _this2.startGame(0);
            });
            //  if (isMobile.any) {
            // this._preloader.signals.next.add(function () {
            //       this.startGame(0);
            //   }, this);
            //   } else {
            //      this.startGame(1);
            //   }
        }

        /**
         * @param {boolean} correct
         */

    }, {
        key: "onCanvasResize",
        value: function onCanvasResize(correct) {
            if (correct) {
                _Common2.default.renderer.resize(P3.View.width, P3.View.height);
                if (_Common2.default.scene) {
                    _Common2.default.scene.resize();
                }
            }
        }
    }], [{
        key: "createConfig",
        value: function createConfig() {
            _Common2.default.config = {};
        }
    }]);

    return Main;
}();

exports.default = Main;


function createText(copy, config) {
    config = config || {};
    var cfg = config;
    var textView = void 0;
    if (_Common2.default.language === "ar") {} else {

        cfg.fontFamily = "Noto Sans";

        cfg.fontSize = config.size || config.fontSize || 45;
        cfg.fill = config.fill || 0x565656;
        cfg.align = config.align || "left";
        cfg.letterSpacing = config.letterSpacing || 0;
        if (config.stroke) {
            cfg.stroke = config.stroke;
            cfg.strokeThickness = config.strokeThickness || 8;
        }
        if (config.wordWrap || cfg.wordWrapWidth) {
            cfg.wordWrap = true;
            cfg.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.dropShadow || cfg.dropShadowDistance) {
            cfg.dropShadow = true;
            cfg.dropShadowDistance = config.dropShadowDistance || 8;
        }

        textView = new PIXI.Text(copy, cfg);
    }
    return textView;
}
window.createText = createText;

function sliceButton(copy, icon, cb, ctx) {
    //--some slightly hacky stuff to get nine slice buttons to work nicely--//

    var a = _Common2.default.assets;

    var textView = createText(copy, { size: 14, fill: 0xffffff, fontWeight: "bold" });
    textView.anchor.set(0.5);

    var height = 50; //per pandora guidelines, all buttons 50px high
    var width = textView.width + 80; //per pandora guidelines, 40px each side of text at all times

    var btnBack = new PIXI.mesh.NineSlicePlane(a.texture("pandora_9slice_button_red_standard"), 15, 15, 15, 15);
    btnBack.width = width;
    btnBack.height = height;

    var btnOver = new PIXI.mesh.NineSlicePlane(a.texture("pandora_9slice_button_red_rollover"), 15, 15, 15, 15);
    btnOver.width = width;
    btnOver.height = height;

    var offTexture = _Common2.default.renderer.generateTexture(btnBack);
    var overTexture = _Common2.default.renderer.generateTexture(btnOver);
    _Common2.default.generatedButtonTextures.push(overTexture, offTexture); //push them so we can destroy textures between scenes

    var states = new P3.ButtonStates();
    states.normal = offTexture;
    states.over = overTexture;

    if (icon) states.icon = a.texture("icon_" + icon);
    var btn = new P3.Button(states);

    btnBack.destroy();
    btnOver.destroy();

    btn.overSoundName = "sfx_btn_over_01";
    btn.clickSoundName = "sfx_btn_down_01";
    btn.signals.click.add(cb, ctx);

    /*
     //--more weird crap to handle changing font tint etc--//
     let overArea = P3.utils.sprite(PIXI.Texture.EMPTY, btn, new PIXI.Point(0.5, 0.5));
     overArea.width = btn.width;
     overArea.height = btn.height;
     overArea.interactive = true;
       overArea.mouseover = (e)=> {
     if (btn.textView) {
     // btn.textView.tint = 0xffffff;
     }
     if (btn.altIcon) {
     btn._icon.texture = a.texture(btn.overTextureName);
     }
     };
     overArea.mouseout = (e)=> {
     if (btn.textView) {
     // btn.textView.tint = 0x6a55a4;
     }
     if (btn.altIcon) {
     btn._icon.texture = a.texture(btn.upTextureName);
     }
     };
     */

    btn.textView = textView;
    btn.addChild(textView);

    return btn;
}
window.sliceButton = sliceButton;

},{"./../scenes/GenericPreloaderScene":12,"./Application":2,"./Bump":3,"./Common":4,"ismobilejs":1}],6:[function(require,module,exports){
/**
 * Created by noOne on 19/02/2018.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StackedSprite = require("./StackedSprite");

var _StackedSprite2 = _interopRequireDefault(_StackedSprite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Player = function (_PIXI$Container) {
    _inherits(Player, _PIXI$Container);

    function Player() {
        _classCallCheck(this, Player);

        //   this._stackHeight = 12;

        var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this));

        _this._layers = [];

        // this.scale.set(2);
        var t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        var sheet = t("chr_sliced").baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;

        var hei = 21;
        var wid = 20;

        var textures = [];
        var total = sheet.width / wid;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (var i = 0; i < total - 1; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(i * wid, 0, wid, hei)));
        }

        //textures = textures.reverse();

        _this._textures = textures;

        _this.init();

        return _this;
    }

    _createClass(Player, [{
        key: "init",
        value: function init() {
            for (var i = 0; i <= this._textures.length; i++) {
                //  let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
                var sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
                //sp.width = 16;
                sp.anchor.set(0.5);
                // sp.tilePosition.x = Math.round(Math.random() * 32);
                // sp.tilePosition.y = Math.round(Math.random() * 32);
                sp.y = -i * 4;
                sp.scale.set(4);

                // if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
                //  if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

                this._layers.push(sp);
                this.addChild(sp);
            }

            this._layers[0].width = 25;
            this._layers[0].height = 25;

            // this.scale.set(4);
        }
    }, {
        key: "setRotation",
        value: function setRotation(rotation) {
            for (var i = 0; i < this._layers.length; i++) {
                this._layers[i].rotation = rotation;
            }
        }
    }, {
        key: "test",
        value: function test() {
            for (var i = 0; i < this._layers.length; i++) {
                this._layers[i].rotation += deltaTime * 0.25;
            }
        }
    }, {
        key: "collisionRect",
        get: function get() {
            return this._layers[0];
        }
    }]);

    return Player;
}(PIXI.Container);

exports.default = Player;

},{"./StackedSprite":9}],7:[function(require,module,exports){
/**
 * Created by noOne on 19/02/2018.
 */
"use strict";

/**
 * @class Class that uses Perlin noise to provide a camera shake effect (will shake any display object, use on world container for camera shake)
 * @author Owain Bell - PlayerThree - 2018
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Shake = function () {
    function Shake() {
        _classCallCheck(this, Shake);

        /**
         * Perlin noise generator
         * @member {SimplexNoise}
         * @private
         */
        this._simplex = new SimplexNoise();

        /**
         * Trauma level, increase to add to trauma
         * @member {number}
         * @private
         */
        this._trauma = 0;

        /**
         * Should shake include rotation?
         * @member{boolean}
         * @private
         */
        this._useRotation = false;

        /**
         * The display object we want to shake
         * @member {null|PIXI.Point|PIXI.DisplayObject}
         * @private
         */
        this._shakeTarget = null;

        /**
         * Position of object before shake, use to reset position each frame and at end of animation.
         * Set when setting the trauma level when the target isn't already shaking
         * @member {null|PIXI.Point}
         * @private
         */
        this._shakeStart = null;

        /**
         * @deprecated
         * @member {number}
         * @private
         */
        this._shakeTime = -1;

        /**
         * How quickly should the trauma fade, higher levels result in quicker fade
         * @member {number}
         * @private
         */
        this._traumaFade = 0.5;

        /**
         * Max X offset for shake.  Increase to turn up shake violence.
         * @member {number}
         * @private
         */
        this._maxOffsetX = 20;

        /**
         * Max Y offset for shake.  Increase to turn up shake violence.
         * @member {number}
         * @private
         */
        this._maxOffsetY = 20;

        /**
         * Max rotational offset for shake.  Increase to turn up shake violence.
         * @member {number}
         * @private
         */
        this._maxRot = Math.PI * 0.02;

        /**
         * Is shaking flag
         * @member {boolean}
         * @private
         */
        this._shaking = false;

        /**
         * Random seed
         * @member {*|number|BigNumber}
         * @private
         */
        this._seed = Math.random();

        /**
         * Step is incremented each frame, for our stepped procedural noise generator
         * @member {number}
         * @private
         */
        this._step = 0;

        /**
         * Rotational centre point
         * @member {PIXI.Point}
         * @private
         */
        this._centre = null;

        /**
         * Optional callback function for when shake ends
         * @member {null|function}
         * @private
         */
        this._onShakeEnd = null;
    }

    _createClass(Shake, [{
        key: "update",
        value: function update(dt) {

            if (this._useRotation && this._centre) {
                this._shakeTarget.pivot.set(this._centre.x + (this._shakeTarget.x - Common.STAGE_WIDTH * 0.5), this._centre.y + (this._shakeTarget.y - Common.STAGE_HEIGHT * 0.5));
            }

            if (!this._shakeTarget || !this._shaking) return;

            this._resetTarget();

            var offsetX = this._trauma * this._maxOffsetX * this._simplex.noise(this._seed, this._step);
            var offsetY = this._trauma * this._maxOffsetY * this._simplex.noise(this._seed + 1, this._step);

            this._shakeTarget.x += offsetX;
            this._shakeTarget.y += offsetY;

            if (this._useRotation) {
                var offsetR = this._trauma * this._maxRot * this._simplex.noise(this._seed + 2, this._step);
                this._shakeTarget.rotation += offsetR;
            }

            this._trauma -= dt * this._traumaFade;
            this._step++;

            if (this._trauma < 0) {
                this._end();
            }
        }
    }, {
        key: "setTarget",
        value: function setTarget(target) {
            target = target || this._shakeTarget;
            this._shakeTarget = target;
            this._shakeStart = new PIXI.Point(target.x, target.y);
            this._shakeStartRot = target.rotation;
            this._step = 0;
        }
    }, {
        key: "setRotCentre",
        value: function setRotCentre(point) {
            this._centre = point;
        }
    }, {
        key: "_end",
        value: function _end() {
            this._resetTarget();
            this._shaking = false;
            if (this._onShakeEnd) this._onShakeEnd(); //cb
        }
    }, {
        key: "_resetTarget",
        value: function _resetTarget() {
            this._shakeTarget.position.set(this._shakeStart.x, this._shakeStart.y);
            this._shakeTarget.rotation = this._shakeStartRot;
        }
    }, {
        key: "trauma",
        get: function get() {
            return this._trauma;
        },
        set: function set(value) {

            //todo - should we make new start when trauma is incremented?
            if (this._shakeTarget && !this._shaking) {
                this._shakeStart = new PIXI.Point(this._shakeTarget.x, this._shakeTarget.y);
            }

            this._shaking = true;
            this._trauma = value;

            //capped at 0-1 range
            if (this._trauma > 1) {
                this._trauma = 1;
            }
        }
    }, {
        key: "useRotation",
        get: function get() {
            return this._useRotation;
        },
        set: function set(value) {
            this._useRotation = value;
        }
    }, {
        key: "maxOffsetX",
        get: function get() {
            return this._maxOffsetX;
        },
        set: function set(value) {
            this._maxOffsetX = value;
        }
    }, {
        key: "maxOffsetY",
        get: function get() {
            return this._maxOffsetY;
        },
        set: function set(value) {
            this._maxOffsetY = value;
        }
    }, {
        key: "maxRot",
        get: function get() {
            return this._maxRot;
        },
        set: function set(value) {
            this._maxRot = value;
        }
    }, {
        key: "traumaFade",
        get: function get() {
            return this._traumaFade;
        },
        set: function set(value) {
            this._traumaFade = value;
        }
    }, {
        key: "onShakeEnd",
        set: function set(value) {
            this._onShakeEnd = value;
        }
    }]);

    return Shake;
}();

//-- converted to javascript from java code found in this paper -- http://staffwww.itn.liu.se/~stegu/simplexnoise/simplexnoise.pdf --//
/**
 * @class - Perlin noise generator, generates stepped procedural noise, more ordered and pleasing than pure randomness.
 */


exports.default = Shake;

var SimplexNoise = function () {
    function SimplexNoise() {
        _classCallCheck(this, SimplexNoise);

        this._grad3 = [[1, 1, 0], [-1, 1, 0], [1, -1, 0], [-1, -1, 0], [1, 0, 1], [-1, 0, 1], [1, 0, -1], [-1, 0, -1], [0, 1, 1], [0, -1, 1], [0, 1, -1], [0, -1, -1]];

        this._p = new Array(256);

        // To remove the need for index wrapping, double the permutation table length
        this._perm = new Array(512);

        this.init();
    }

    _createClass(SimplexNoise, [{
        key: "init",
        value: function init() {

            for (var i = 0; i < this._p.length; i++) {
                this._p[i] = Math.floor(Math.random() * 256); //fill with random bit strings
            }

            for (var _i = 0; _i < this._perm.length; _i++) {
                this._perm[_i] = this._p[_i & 255];
            }
        }
    }, {
        key: "noise",
        value: function noise(xIn, yIn) {
            // 2D simplex noise

            var n0 = void 0,
                n1 = void 0,
                n2 = void 0; //noise contributions from three corners

            // Skew the input space to determine which simplex cell we're in
            var f2 = 0.5 * (Math.sqrt(3) - 1);
            var s = (xIn + yIn) * f2;
            var i = Math.floor(xIn + s);
            var j = Math.floor(yIn + s);

            var g2 = (3 - Math.sqrt(3)) / 6;
            var t = (i + j) * g2;
            var X0 = i - t; //Unskew cell origin back to (x, y) space
            var Y0 = j - t; //^
            var x0 = xIn - X0; //distances from cell origin
            var y0 = yIn - Y0; //^

            //Note - for 2d, the simplex shape is a equilateral triangle
            //determine which simplex we are
            var i1 = void 0,
                j1 = void 0; //offsets for 2nd (middle) corner of simplex in (i,j) coords

            if (x0 > y0) {
                // lower triangle, XY order: (0,0)->(1,0)->(1,1)
                i1 = 1;
                j1 = 0;
            } else {
                // upper triangle, YX order: (0,0)->(0,1)->(1,1)
                i1 = 0;
                j1 = 1;
            }

            // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
            // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
            // c = (3-sqrt(3))/6

            var x1 = x0 - i1 + g2; //offsets for middle corner in (x,y) unskewed coords
            var y1 = y0 - j1 + g2;
            var x2 = x0 - 1 + 2 * g2;
            var y2 = y0 - 1 + 2 * g2;

            // work out the hashed gradient indices of the three simplex corners
            var ii = i & 255;
            var jj = j & 255;
            var gi0 = this._perm[ii + this._perm[jj]] % 12;
            var gi1 = this._perm[ii + i1 + this._perm[jj + j1]] % 12;
            var gi2 = this._perm[ii + 1 + this._perm[jj + 1]] % 12;

            //calculate the contribution from the three corners
            var t0 = 0.5 - x0 * x0 - y0 * y0;
            if (t0 < 0) {
                n0 = 0;
            } else {
                t0 *= t0;
                n0 = t0 * t0 * SimplexNoise.dotProduct(this._grad3[gi0][0], this._grad3[gi0][1], x0, y0); // (x,y) of grad3 used for 2D gradient
            }

            var t1 = 0.5 - x1 * x1 - y1 * y1;
            if (t1 < 0) {
                n1 = 0;
            } else {
                t1 *= t1;
                n1 = t1 * t1 * SimplexNoise.dotProduct(this._grad3[gi1][0], this._grad3[gi1][1], x1, y1);
            }

            var t2 = 0.5 - x2 * x2 - y2 * y2;
            if (t2 < 0) {
                n2 = 0;
            } else {
                t2 *= t2;
                n2 = t2 * t2 * SimplexNoise.dotProduct(this._grad3[gi2][0], this._grad3[gi2][1], x2, y2);
            }

            // Add contributions from each corner to get the final noise value.
            // The result is scaled to return values in the interval [-1,1].
            return 70.0 * (n0 + n1 + n2);
        }
    }], [{
        key: "dotProduct",
        value: function dotProduct(x0, y0, x1, y1) {
            return x0 * x1 + y0 * y1;
        }
    }]);

    return SimplexNoise;
}();

},{}],8:[function(require,module,exports){
/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackedSprite = function (_PIXI$Container) {
    _inherits(StackedSprite, _PIXI$Container);

    function StackedSprite() {
        _classCallCheck(this, StackedSprite);

        //   this._stackHeight = 12;

        var _this = _possibleConstructorReturn(this, (StackedSprite.__proto__ || Object.getPrototypeOf(StackedSprite)).call(this));

        _this._layers = [];

        // this.scale.set(2);
        var t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        var sheet = t("cube").baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;
        var textures = [];
        var total = sheet.width / 32;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (var i = 0; i < total; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(Math.round(i * 32), 0, 32, 32)));
        }

        _this._textures = textures;

        _this.init();
        return _this;
    }

    _createClass(StackedSprite, [{
        key: "init",
        value: function init() {

            var t = Common.assets.texture;
            for (var i = 0; i <= this._textures.length; i++) {
                //  let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
                var sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
                //sp.width = 16;
                sp.anchor.set(0.5);
                // sp.tilePosition.x = Math.round(Math.random() * 32);
                // sp.tilePosition.y = Math.round(Math.random() * 32);
                sp.y = -i * 4;
                sp.scale.set(2);

                // if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
                //  if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

                this._layers.push(sp);
                this.addChild(sp);
            }

            // this.scale.set(4);

            //  if (!isPyramid) {
            /*
             let sp = P3.utils.sprite(t("dirt_top"), this, new PIXI.Point(0.5, 0.5));
             sp.y = -25;
             this._layers.push(sp);
               sp.scale.set(2);
             */
            //  }
        }
    }, {
        key: "update",
        value: function update(dir) {
            for (var i = 0; i < this._layers.length; i++) {
                this._layers[i].rotation += deltaTime * dir;
            }
        }
    }]);

    return StackedSprite;
}(PIXI.Container);

exports.default = StackedSprite;

},{}],9:[function(require,module,exports){
/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackedDuplicate = function (_PIXI$Container) {
    _inherits(StackedDuplicate, _PIXI$Container);

    function StackedDuplicate(name, frameWidth, frameHeight) {
        _classCallCheck(this, StackedDuplicate);

        var _this = _possibleConstructorReturn(this, (StackedDuplicate.__proto__ || Object.getPrototypeOf(StackedDuplicate)).call(this));

        _this._layers = [];
        _this._collisionRect = null;

        // this.scale.set(2);
        var t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        var sheet = t(name).baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;

        var wid = frameWidth;
        var hei = frameHeight;

        var textures = [];
        var total = sheet.width / wid;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (var i = 0; i < total - 1; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(i * wid, 0, wid, hei)));
        }

        if (name === "tree") _this._isTree = true;
        //textures = textures.reverse();

        _this._textures = textures;

        _this.init();
        return _this;
    }

    _createClass(StackedDuplicate, [{
        key: "init",
        value: function init() {

            for (var i = 0; i <= this._textures.length; i++) {
                //let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
                var sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
                //sp.width = 16;
                sp.anchor.set(0.5);
                //sp.tilePosition.x = Math.round(Math.random() * 32);
                //sp.tilePosition.y = Math.round(Math.random() * 32);
                if (!this._isTree) {
                    sp.y = -i;
                } else {
                    sp.y = -i * 8;
                    sp.scale.set(4);
                }
                // * 12;
                //sp.scale.set(81);

                //if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
                //if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

                this._layers.push(sp);
                this.addChild(sp);
            }
        }
    }, {
        key: "update",
        value: function update(dir) {
            for (var i = 0; i < this._layers.length; i++) {
                this._layers[i].rotation += deltaTime * dir;
            }

            //this._collisionRect.rotation += deltaTime * dir;
        }
    }, {
        key: "collisionRect",
        get: function get() {
            return this._layers[0];
        }
    }]);

    return StackedDuplicate;
}(PIXI.Container);

exports.default = StackedDuplicate;

},{}],10:[function(require,module,exports){
(function (global){
'use strict';

var _Main = require('./core/Main');

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.Main = _Main2.default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./core/Main":5}],11:[function(require,module,exports){
/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _StackedSprite = require("./../game/StackedSprite");

var _StackedSprite2 = _interopRequireDefault(_StackedSprite);

var _StackedDuplicate = require("./../game/StackedDuplicate");

var _StackedDuplicate2 = _interopRequireDefault(_StackedDuplicate);

var _Player = require("./../game/Player");

var _Player2 = _interopRequireDefault(_Player);

var _Shake = require("./../game/Shake");

var _Shake2 = _interopRequireDefault(_Shake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GameScene = function (_P3$Scene) {
        _inherits(GameScene, _P3$Scene);

        function GameScene() {
                _classCallCheck(this, GameScene);

                var _this = _possibleConstructorReturn(this, (GameScene.__proto__ || Object.getPrototypeOf(GameScene)).call(this));

                _this._player = null;

                _this._stackedSprites = [];
                _this._stackedHolder = new PIXI.Container();

                _this._bgHolder = new PIXI.Container();

                _this._bg = null;

                _this._testPos = [{ "x": 895, "y": 735 }, { "x": 1609, "y": 415 }, { "x": 1769, "y": 15 }, { "x": 1178, "y": 126 }, { "x": 340, "y": 593 }, { "x": 1292, "y": 447 }, { "x": 1167, "y": 214 }, { "x": 1613, "y": 526 }, { "x": 1603, "y": 404 }, { "x": 762, "y": 430 }, { "x": 280, "y": 269 }, { "x": 346, "y": 425 }, { "x": 110, "y": 677 }, { "x": 271, "y": 372 }, { "x": 561, "y": 573 }, { "x": 814, "y": 129 }, { "x": 285, "y": 700 }, { "x": 1490, "y": 533 }, { "x": 1367, "y": 458 }, { "x": 471, "y": 538 }, { "x": 95, "y": 172 }, { "x": 319, "y": 696 }, { "x": 842, "y": 667 }, { "x": 1227, "y": 90 }, { "x": 1110, "y": 532 }, { "x": 1204, "y": 749 }, { "x": 1387, "y": 62 }, { "x": 347, "y": 688 }, { "x": 1537, "y": 458 }, { "x": 597, "y": 621 }];

                return _this;
        }

        _createClass(GameScene, [{
                key: "init",
                value: function init() {

                        Common.renderer.backgroundColor = 0xaccc2e;

                        this.addChild(this._stackedHolder);

                        // const pos = [];
                        console.log("foo");

                        for (var i = 0; i < 30; i++) {

                                var stacked = i < 15 ? new _StackedSprite2.default("house", 64, 64) : new _StackedSprite2.default("tree", 10, 10);
                                this._stackedHolder.addChild(stacked);

                                //  stacked.x = Common.STAGE_WIDTH * 0.5 + P3.math.randomInt(-Common.STAGE_WIDTH * 0.5, Common.STAGE_WIDTH * 0.5);
                                // stacked.y = Common.STAGE_HEIGHT * 0.5 + P3.math.randomInt(-Common.STAGE_HEIGHT * 0.5, Common.STAGE_HEIGHT * 0.5);

                                this._stackedSprites.push(stacked);

                                //pos.push(new PIXI.Point(stacked.x, stacked.y));


                                stacked.x = this._testPos[i].x;
                                stacked.y = this._testPos[i].y;
                        }

                        // console.log(JSON.stringify(pos));

                        this._player = new _Player2.default();
                        this._stackedHolder.addChild(this._player);

                        this._player.x = Common.STAGE_WIDTH * 0.5;
                        this._player.y = Common.STAGE_HEIGHT * 0.5;
                        this._player.setRotation(Math.PI);

                        this._stackedHolder.x = Common.STAGE_WIDTH * 0.5;
                        this._stackedHolder.y = Common.STAGE_HEIGHT * 0.5;

                        this.testNoise();
                        /*
                         let sp1 = P3.utils.sprite(PIXI.Texture.WHITE, this._stackedHolder, new PIXI.Point(0.5, 0.5));
                         sp1.tint = 0xff0000;
                         sp1.scale.set(10);
                         sp1.x = Common.STAGE_WIDTH * 0.5;
                         sp1.y = Common.STAGE_HEIGHT * 0.5;
                         sp1.x -= 75;
                           let sp2 = P3.utils.sprite(PIXI.Texture.WHITE, this._stackedHolder, new PIXI.Point(0.5, 0.5));
                         sp2.tint = 0x0000ff;
                         sp2.scale.set(10);
                         sp2.x = Common.STAGE_WIDTH * 0.5;
                         sp2.y = Common.STAGE_HEIGHT * 0.5;
                         sp2.x += 75;
                           if (Common.bump.hitTestRectangle(sp1, sp2)) {
                         //hit = "up";
                         console.log("bump");
                         }
                         */
                }
        }, {
                key: "testNoise",
                value: function testNoise() {
                        this._shake = new _Shake2.default();
                        this._shake.setTarget(this._stackedHolder);
                        this._shake.setRotCentre(this._player);
                        //  this._shake.trauma = 1;
                        this._shake.useRotation = true;
                }
        }, {
                key: "destroy",
                value: function destroy() {
                        _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "destroy", this).call(this, { children: true });
                }
        }, {
                key: "appear",
                value: function appear() {
                        _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "appear", this).call(this);
                }
        }, {
                key: "resize",
                value: function resize() {
                        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
                }
        }, {
                key: "update",
                value: function update() {

                        //this._player.test();

                        //test shake
                        if (Common.input.isKeyPressed(32)) {
                                //w
                                this._shake.trauma += 0.25;
                        }

                        this._shake.update(deltaTime);

                        //--depth sort--//
                        this._stackedHolder.children.sort(function (a, b) {
                                return a.y - b.y;
                        });

                        var dir = null;
                        if (Common.input.isKeyDown(81)) {
                                dir = -1;
                        } else if (Common.input.isKeyDown(69)) {
                                dir = 1;
                        }

                        dir = 0.1;

                        //--cycle array checking all cardinal directions for collisions--//
                        var hit = null;
                        for (var i = 0; i < this._stackedSprites.length; i++) {
                                var ss = this._stackedSprites[i];

                                var result = P3.utils.collide(this._player.collisionRect, ss.collisionRect);
                                if (result) {

                                        hit = true;

                                        if (this._player.x < ss.x) this._player.x -= 1;
                                        if (this._player.x > ss.x) this._player.x += 1;
                                        if (this._player.y < ss.y) this._player.y -= 1;
                                        if (this._player.y > ss.y) this._player.y += 1;
                                }
                        }

                        //no need to update rotation if rotate key isn't down or we are touching a wall
                        if (dir && !hit) {
                                for (var _i = 0; _i < this._stackedSprites.length; _i++) {
                                        var _ss = this._stackedSprites[_i];
                                        _ss.update(dir);
                                        this._rotateAround(this._player.x, this._player.y, deltaTime * dir, _ss);
                                }

                                //this._bg.rotation += deltaTime * dir;
                        }

                        //if (hit) console.log(hit);

                        //--check for collisions--//
                        if (Common.input.isKeyDown(87) && !hit) {
                                //w
                                // this._stackedHolder.y += 2;
                                this._player.y -= 2;
                                this._player.setRotation(0);
                        }

                        if (Common.input.isKeyDown(83) && !hit) {
                                //s
                                // this._stackedHolder.y -= 2;
                                this._player.y += 2;
                                this._player.setRotation(Math.PI);
                        }

                        if (Common.input.isKeyDown(65) && !hit) {
                                //a
                                // this._stackedHolder.x += 2;
                                this._player.x -= 2;
                                this._player.setRotation(Math.PI * 0.5);
                        }

                        if (Common.input.isKeyDown(68) && !hit) {
                                //d
                                // this._stackedHolder.x -= 2;
                                this._player.x += 2;
                                this._player.setRotation(-Math.PI * 0.5);
                        }

                        this._stackedHolder.x = -this._player.x;
                        this._stackedHolder.y = -this._player.y;
                }
        }, {
                key: "end",
                value: function end() {
                        this.signals.next.dispatch(this);
                }

                /**
                 * @param cx - pivot x
                 * @param cy - pivot y
                 * @param angle - angle to rotate by
                 * @param p - point to rotate
                 * @returns {*}
                 */

        }, {
                key: "_rotateAround",
                value: function _rotateAround(cx, cy, angle, p) {
                        var s = Math.sin(angle);
                        var c = Math.cos(angle);

                        // translate point back to origin:
                        p.x -= cx;
                        p.y -= cy;

                        // rotate point
                        var xnew = p.x * c - p.y * s;
                        var ynew = p.x * s + p.y * c;

                        // translate point back:
                        p.x = xnew + cx;
                        p.y = ynew + cy;

                        return p;
                }
        }]);

        return GameScene;
}(P3.Scene);

exports.default = GameScene;

},{"./../game/Player":6,"./../game/Shake":7,"./../game/StackedDuplicate":8,"./../game/StackedSprite":9}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./../core/Common");

var _Common2 = _interopRequireDefault(_Common);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Generic Preloader for prototyping
 * @class
 */
var GenericPreloaderScene = function (_P3$Scene) {
    _inherits(GenericPreloaderScene, _P3$Scene);

    function GenericPreloaderScene() {
        _classCallCheck(this, GenericPreloaderScene);

        var _this = _possibleConstructorReturn(this, (GenericPreloaderScene.__proto__ || Object.getPrototypeOf(GenericPreloaderScene)).call(this));

        _this.loaded = 0;
        _this._bar = new PIXI.Sprite(PIXI.Texture.WHITE);
        _this._barWidth = 375;
        _this._text = createText("loading", { fill: 0x000000 });

        return _this;
    }

    _createClass(GenericPreloaderScene, [{
        key: "init",
        value: function init() {
            _get(GenericPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(GenericPreloaderScene.prototype), "init", this).call(this);

            this._bar.position.set(_Common2.default.STAGE_WIDTH * 0.5 - this._barWidth * 0.5, P3.View.height * 0.5);
            this._bar.width = 0;
            this._bar.height = 25;
            this._bar.anchor = new PIXI.Point(0, 0.5);
            this._bar.tint = 0x000000;

            this._text.anchor.set(0.5);
            this._text.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._text.y = _Common2.default.STAGE_HEIGHT * 0.5 - 75;

            this.addChild(this._bar, this._text);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(GenericPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(GenericPreloaderScene.prototype), "destroy", this).call(this, { children: true });
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(GenericPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(GenericPreloaderScene.prototype), "appear", this).call(this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (P3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            var loaded = Math.min(1, this.loaded);
            this._bar.width = loaded * this._barWidth;
        }
    }, {
        key: "onLoadComplete",
        value: function onLoadComplete() {
            var _this2 = this;

            var overlay = P3.utils.sprite(PIXI.Texture.WHITE, this, new PIXI.Point(0.5, 0));
            overlay.width = _Common2.default.STAGE_WIDTH;
            overlay.height = _Common2.default.STAGE_HEIGHT;
            overlay.x = _Common2.default.STAGE_WIDTH * 0.5;
            overlay.alpha = 0;
            TweenMax.to(overlay, 0.5, { alpha: 1, ease: Power0.easeNone, onComplete: function onComplete() {
                    return _this2.end();
                } });
        }
    }, {
        key: "end",
        value: function end() {
            this.signals.next.dispatch(this);
        }
    }]);

    return GenericPreloaderScene;
}(P3.Scene);

exports.default = GenericPreloaderScene;

},{"./../core/Common":4,"ismobilejs":1}]},{},[10])

